import { WorkspaceDataHelper } from './../../../../services/helpers/workspace-data.helper';
import { BacklogRollupHelper } from './../../../../services/helpers/backlog-rollup.helper';
import { EventManagerHelper } from './../../../../services/event-managers/event.manager.helper';
import { ToolbarEventManagerHelper } from './../../../../services/event-managers/toolbar-event-manager.helper';
import { FieldHelper } from './../../../../services/helpers/field.helper';
import { flattenListRowBlocks, flattenListRowBlocksInRows } from './../../../../services/helpers/rich-text-content.helper';
import { CommentStore } from '../../../../services/stores/comment.store';
import { CommentModel } from '../../../../models/comment.model';
import { List } from 'immutable';
import { IAttachmentModel } from './../../../../models/attachment/attachment.model';
import { AttachmentsStore } from './../../../../services/stores/attachments.store';
import { ISaveWorkEventModel, ISetFocusEvent } from '../../../../models/base/event-base.model';
import { NodeHelper } from './../../../../services/helpers/node.helper';
import { ITestStepInstanceModel, NavigationDirections } from './../../../../models/test-step/test-step-instance.model';
import { ITestTableRowModel } from './../../../../models/test-step/test-table-row.model';
import { TestStepNavigationHelper } from './../../../../services/helpers/test-step-navigation.helper';
import { BlueprintDataHelper } from './../../../../services/helpers/blueprint-data.helper';
import { BlueprintPropertyBindingHelper } from './../../../../services/helpers/blueprint-property-binding.helper';
import { BlueprintStore } from './../../../../services/stores/blueprint.store';
import { UserDataHelper } from '../../../../services/helpers/user-data.helper';
import { IFieldValueConfigurationModel } from './../../../../models/app-setting/app-setting.model';
import { IBluePrintNodeModel } from './../../../../models/blueprint/blueprint-node.model';
import { NodeFactory } from '../../../../services/factories/node.factory';
import { ProjectStore } from '../../../../services/stores/projects.store';
import { PatchNodeInstancePayload } from './../../../../models/node/patch-node-instance-payload.model';
import { WorkspaceStore } from '../../../../services/stores/workspace.store';
import { AlertService } from './../../../../services/alert.service';
import { Helper } from './../../../../services/helper.service';
import { DashboardHelper } from './../../../../services/dashboard.service';
import { IMappedEntityModel } from './../../../../models/project/mapped-entity.model';
import { IProjectModel, ITreeNode } from './../../../../models/project/project.model';
import { NodeInstanceModel } from './../../../../models/node/node-instance.model';
import * as AppConstants from '../../../catch-core/data/constants/app.constants';
import * as DefaultValueConstants from '../../../catch-core/data/constants/default-value.constants';
import { ClassicETAPIService } from '../../../../services/api/classic-et.api.service';
import { IBluePrintModel } from '../../../../models/blueprint/blueprint.model';
import { UserStore } from '../../../../services/stores/user.store';
import { Component, ElementRef, Input, ViewChild, AfterViewInit, ChangeDetectorRef, OnDestroy, DoCheck, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NotificationType } from 'angular2-notifications';
import { BaseComponent } from '../../../../components/base/base.component';
import { FieldModel, ITespStepInputFieldModel } from '../../../../models/blueprint/blueprint-field.model';
import { WorkspaceService } from '../../../../services/workspace.service';
import { ProjectService } from '../../../../services/project.service';
import { JiraHelper } from '../../../../services/jira.service';
import { LoggerService } from '../../../../services/logger.service';
import { IWorkspaceInstanceModel } from '../../../../models/workspace/workspace-instance.model';
import * as BluePrintConstants from '../../../../modules/catch-core/data/constants/blueprint.constants';
import * as NotificationConstants from '../../../../modules/catch-core/data/constants/notification.constants';
import _ from 'lodash';
import { INodeInstanceViewModel } from './../../../../models/node/node-instance.view.model';
import { AppModuleName } from '../../../../modules/catch-core/data/enum/app-module-name.enum';
import { WebElementName } from '../../../../modules/catch-core/data/enum/web-elements-name.enum';
import { TestStep } from '../../modules/test-step-table/models/test-step.model';
import { UserModel } from '../../../../models/user/user.model';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { EditPanelUiHelperService } from '../../services/edit-panel-ui.helper';
import { EditPanelHeaderComponent, IChildNodeChip } from '../edit-panel-header/edit-panel-header.component';
import { EditPanelDetailsPaneComponent } from '../edit-panel-details-pane/edit-panel-details-pane.component';
import { EditPanelTargetMapHelperService } from '../../services/edit-panel-target-map.helper';
import { EditPanelDateHelperService } from '../../services/edit-panel-date.helper';
import { EditPanelTestStepHelperService, TestStatusConfig } from '../../services/edit-panel-test-step.helper';
import { EditPanelDataHelperService } from '../../services/edit-panel-data.helper';
import { NodeTableHelper } from '../../../../services/helpers/node-table.helper';
import { IntelliCatchAvailabilityHelper } from '../../../../services/helpers/intellicatch-availability.helper';
import { IntelliCatchAvailabilityState } from '../../../../models/copilot/intellicatch-availability.enum';

type TestStepFieldNames = keyof ITestStepInstanceModel;
type EditPanelTab = 'overview' | 'attachments' | 'comments' | 'steps' | 'runs' | 'history';

@Component({
  selector: 'app-edit-panel-container',
  templateUrl: './edit-panel-container.component.html',
  styleUrls: ['./edit-panel-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EditPanelContainerComponent extends BaseComponent implements AfterViewInit, OnDestroy, DoCheck {
  @Input() hideNavigation = false;

  @ViewChild('parentPanel') parentPanelElement!: ElementRef<HTMLDivElement>;
  @ViewChild(EditPanelHeaderComponent) headerComponent?: EditPanelHeaderComponent;
  @ViewChild('myForm') myForm!: NgForm;
  @ViewChild(EditPanelDetailsPaneComponent) detailsPaneComponent?: EditPanelDetailsPaneComponent;
  @ViewChild('dateCalendar') dateCalendarRef: any;

  public readonly editPanelTabs: { id: EditPanelTab; label: string }[] = [
    { id: 'overview', label: 'Overview' },
    { id: 'attachments', label: 'Attachments' },
    { id: 'comments', label: 'Comments' },
    { id: 'steps', label: 'Steps' },
    { id: 'runs', label: 'Runs' },
    { id: 'history', label: 'History' },
  ];
  public activeTab: EditPanelTab = BluePrintConstants.OVERVIEW_TAB;
  // The tab the user last picked. Kept separate from activeTab so moving between items stays on
  // it (e.g. stepping through tests on Steps), and so an item that can't show it (a Bug has no
  // Steps tab) only falls back to Overview for that item rather than forgetting the choice. Lives
  // on the component, which the dashboard destroys when the panel closes, so a fresh open still
  // starts on Overview.
  private preferredTab: EditPanelTab = BluePrintConstants.OVERVIEW_TAB;
  public runsCount: number = 0;

  public selectedWorkspaceInstanceNode: NodeInstanceModel;
  private lastLoadedNodeId: string | null = null;
  public selectedWorkspace: IWorkspaceInstanceModel = {} as IWorkspaceInstanceModel;

  public subscribers: any = {};
  public isTestNode = false;
  public selectedTestStep: ITestStepInstanceModel = {} as ITestStepInstanceModel;
  public isDoView = false;

  public selectedNodeStatus: string = '';
  public selectedTestStepStatus: string = '';
  public selectedNodeViewIntance: INodeInstanceViewModel | null = null;

  public formChanged: boolean = false;
  private _wasRightPanelVisible: boolean = false;
  public isTestStepSelected = false;
  public isShowNodeStatus = false;
  public fieldDataArray: any[] = [];
  public fieldTableDataArray: { [fieldId: string]: ITestTableRowModel[] } = {};
  // Id of the node that fieldDataArray / fieldTableDataArray / formData were last built for
  // (stamped at the end of constructFields). $selectedWSINode swaps selectedWorkspaceInstanceNode
  // synchronously on navigation, but constructFields() re-runs in a later setTimeout, so there is
  // a window where these arrays still hold the previous node's data. onGetTableDataOutput uses
  // this to reject a stale test-step emission instead of persisting it onto the new node (ZOO-10027).
  private fieldDataNodeId: string | null = null;
  // JSON of the step table as last loaded from the server, or as last saved. constructTableField
  // aliases fieldTableDataArray/formData/fieldDataArray to a single array, so those cannot be
  // compared against each other to detect an edit - they are the same object. This snapshot is the
  // only stable "last committed" reference point (ZOO-10027).
  private committedStepsJson: string | null = null;
  // Work queued behind the in-flight save (navigate, close the panel). Held on the component
  // rather than only in the subscribe closure so it survives a second save superseding the first
  // — see the unsubscribe in saveWork (ZOO-10027).
  private pendingSaveCallback?: () => void;
  public tableConfigurationArray: any[] = [];
  public testTableFieldIndex: number | null = null;
  public dateLow1 = '1899-12-31T12:30:00Z';
  public dateLow2 = '1900-01-01T00:00:00Z';
  readonly MINIMUM_VALID_YEAR = 2000;
  public nodeStatusIcons: IFieldValueConfigurationModel[] = [];
  public stepStatusIcons: IFieldValueConfigurationModel[] = [];
  public numberOfTestSteps = 0;
  public Math = Math;
  readonly START_DATE_FIELD_NAME = BluePrintConstants.STARTDATEFIELDNAME;
  readonly DUE_DATE_FIELD_NAME = BluePrintConstants.DUEDATEFIELDNAME;
  readonly APPLY_UNIVERSAL_NODE_FIELD_NAME = BluePrintConstants.NODETYPE_UNIVL_TARGET_MAPS_FIELD;
  readonly APPLY_LOCAL_NODE_FIELD_NAME = BluePrintConstants.NODETYPE_LOCAL_TARGET_MAPS_FIELD;
  readonly EXT_APP_REFERENCE_ID_FIELD_NAME = BluePrintConstants.EXT_APP_REFERENCE_ID_FIELD;
  readonly EPIC_NAME_FIELD_NAME = BluePrintConstants.EPIC_NAME_FIELD_LOWER;

  // target maps chips control variable
  public targetMapsUnivlSelected: IMappedEntityModel[] = [];
  public targetMapsLocalSelected: IMappedEntityModel[] = [];
  public allTargetMapsUnivl: IMappedEntityModel[] = [];
  public allTargetMapsLocal: IMappedEntityModel[] = [];
  // Includes archived maps (unlike allTargetMapsUnivl/Local) so a node's already-saved
  // target map references still resolve to a chip after the referenced map is archived.
  public allTargetMapsAny: IMappedEntityModel[] = [];
  public filteredTargetMapsUnivl: IMappedEntityModel[] = [];
  public filteredTargetMapsLocal: IMappedEntityModel[] = [];
  public targetMapsMergedSelected: IMappedEntityModel[] = [];
  public filteredTargetMapsMerged: IMappedEntityModel[] = [];

  public testStepDataTableActive = false;
  public dataChanged = false;
  public locked = false;
  public fieldList: FieldModel[] = [];
  public detailFieldList: FieldModel[] = [];
  public bugFieldList: FieldModel[] = [];
  public testInputFieldList: ITespStepInputFieldModel[] = [];
  public tableField: FieldModel | null = null;
  public localNodeField: FieldModel | null = null;
  public univeralNodeField: FieldModel | null = null;
  public childNodeNameList: IChildNodeChip[] = [];
  public generateTestsState: IntelliCatchAvailabilityState = IntelliCatchAvailabilityState.NotApplicable;
  public generateTestsBlockedReason = '';
  public attachmentsOrg: IAttachmentModel[] = [];
  public formData: { [fieldId: string]: any } = {};
  public canShowEpicNameField = false;
  public descriptionDraft: string = '';
  public isEditingDescription = false;
  public panelWidthPx: number | null = null;
  public readonly buildDropdownOptions = this.editPanelUiHelper.buildDropdownOptions.bind(this.editPanelUiHelper);
  public readonly buildUserDropdownOptions = this.editPanelUiHelper.buildUserDropdownOptions.bind(this.editPanelUiHelper);

  public get commentsCount(): number {
    return this.selectedWorkspaceInstanceNode?.comments?.length ?? 0;
  }

  public get attachmentsCount(): number {
    const selectedNodeViewModel = this.nodeInstanceViewModelList?.find((n) => n.id === this.selectedWorkspaceInstanceNode.id);
    return selectedNodeViewModel?.attachmentReferences?.length ?? 0;
  }

  public get selectedProjectId(): string {
    return this.selectedProject?.id ?? '';
  }

  private className = 'EditPanelContainerComponent';
  private selectedWorkspaceInstanceNodeOldVal: NodeInstanceModel = {} as NodeInstanceModel;
  private selectedBlueprint: IBluePrintModel | null = null;
  private selectedProject: IProjectModel = {} as IProjectModel;
  private oldName: string = '';
  /** The Name text pre-filled into an empty Epic Name box for display; null when nothing was defaulted. */
  private epicNameDisplayDefault: string | null = null;
  private nodeInstanceViewModelList: INodeInstanceViewModel[] | null = [];
  private isEditPanelExpanded: boolean = false;
  private fieldIdTypeDictionary: { [id: string]: string } = {};
  public isPanelResizing = false;
  private readonly minPanelWidthPx = 400;
  private panelDefaultWidthPx = 0;
  private maxPanelWidthPx = 0;
  private resizeStartX = 0;
  private resizeStartWidth = 0;
  private bugNodeType: IBluePrintNodeModel | null = {} as IBluePrintNodeModel;
  private testNodeType: IBluePrintNodeModel | null = {} as IBluePrintNodeModel;
  private extRefField: FieldModel | null = null;
  private testStatusField: FieldModel | null = null;
  private testStepsField: FieldModel | null = null;
  private assignedToField: FieldModel | null = null;
  private storyNodeType: IBluePrintNodeModel | null = {} as IBluePrintNodeModel;
  private epicNodeType: IBluePrintNodeModel | null = {} as IBluePrintNodeModel;
  private taskNodeType: IBluePrintNodeModel | null = {} as IBluePrintNodeModel;
  private subTaskNodeType: IBluePrintNodeModel | null = {} as IBluePrintNodeModel;
  public epicNameField: FieldModel | null = null;
  private userList: UserModel[] = [];
  // Tracks which project this.userList was fetched for, so constructUserField() can skip
  // re-fetching/resetting on a same-project rebuild (e.g. the constructFields() re-run that
  // follows every saveWork() via $selectedWSINode) - otherwise the assignee dropdown flashes
  // through "Loading..." and drops the just-picked value each time the node is saved.
  private userListProjectId: string | null = null;
  private nodeFieldsChanged = false;
  private shouldForceFromParentFalse = false;
  private isAddingTestStep = false;
  private dueDateFieldId = '';
  private startDateFieldId = '';
  private nodeStatusFieldId: string | undefined;

  constructor(
    public dashboardHelper: DashboardHelper,
    private workspaceService: WorkspaceService,
    private projectService: ProjectService,
    private helperService: Helper,
    private editPanelUiHelper: EditPanelUiHelperService,
    private editPanelTargetMapHelper: EditPanelTargetMapHelperService,
    private editPanelDateHelper: EditPanelDateHelperService,
    private editPanelTestStepHelper: EditPanelTestStepHelperService,
    private editPanelDataHelper: EditPanelDataHelperService,
    private alertService: AlertService,
    private jiraHelper: JiraHelper,
    private workspaceStore: WorkspaceStore,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private userStore: UserStore,
    private classicETHelper: ClassicETAPIService,
    private projectStore: ProjectStore,
    private nodeFactory: NodeFactory,
    private userDataHelper: UserDataHelper,
    private blueprintDataHelper: BlueprintDataHelper,
    private blueprintPropertyBindingHelper: BlueprintPropertyBindingHelper,
    private testStepNavigationHelper: TestStepNavigationHelper,
    private nodeHelper: NodeHelper,
    private eventManager: EventManagerHelper,
    private attachmentStore: AttachmentsStore,
    private fieldHelper: FieldHelper,
    private commentStore: CommentStore,
    private workspaceDataHelper: WorkspaceDataHelper,
    private toolbarEventManagerHelper: ToolbarEventManagerHelper,
    private blueprintStore: BlueprintStore,
    private nodeTableHelper: NodeTableHelper,
    private intelliCatchAvailabilityHelper: IntelliCatchAvailabilityHelper,
  ) {
    super();
    this.route.params.subscribe((params) => {});
    this.selectedWorkspaceInstanceNode = this.nodeFactory.createDefaultNodeIntance('', '', '', true);
  }

  @HostListener('document:click', ['$event'])
  public onEditPanelCick(event: MouseEvent): void {
    const targetElement = event.target as HTMLElement;
    if (!targetElement) {
      return;
    }
    const clickedInside = this.isElementInsideWrapper(targetElement) || this.isEditPanelExpanded;
    if (!clickedInside) {
      if ((this.myForm?.form.dirty && this.myForm?.form.touched) || this.formChanged) {
        this.saveWork(false, true);
        this.myForm.form.markAsPristine();
      }
    }
  }

  public selectEditPanelTab(tabId: EditPanelTab): void {
    if (tabId === BluePrintConstants.COMMENTS_TAB && this.isTestStepSelected && this.isDoView) {
      return;
    }
    if (!this.isTabAvailable(tabId)) {
      tabId = BluePrintConstants.OVERVIEW_TAB;
    }
    if (this.activeTab === tabId) return;
    this.preferredTab = tabId;
    // Leaving a tab tears down whatever it was rendering — including the step table and the cell
    // the user is mid-edit in. That edit only lives in fieldDataArray at this point, so flush it to
    // the server now, while this node is still the selected one. saveWork() snapshots the payload
    // synchronously, so the tab can switch straight away without waiting for the response, and the
    // node guard inside saveWork() still prevents it landing anywhere else (ZOO-10027).
    if (this.hasUnsavedWork()) {
      this.saveWork();
    }
    this.activeTab = tabId;
  }

  public startDescriptionEdit(): void {
    if (this.isEditingDescription) return;
    this.descriptionDraft = this.selectedWorkspaceInstanceNode?.description ?? '';
    this.isEditingDescription = true;
  }

  public cancelDescriptionEdit(): void {
    this.descriptionDraft = '';
    this.isEditingDescription = false;
  }

  public saveDescriptionEdit(): void {
    if (!this.selectedWorkspaceInstanceNode) {
      this.cancelDescriptionEdit();
      return;
    }
    const newDescription = this.descriptionDraft ?? '';
    // Skip the network write when nothing changed (e.g. blur auto-save without edits).
    if (newDescription === (this.selectedWorkspaceInstanceNode.description ?? '')) {
      this.cancelDescriptionEdit();
      return;
    }
    this.selectedWorkspaceInstanceNode.description = this.descriptionDraft ?? '';
    this.onChange(this.selectedWorkspaceInstanceNode.description);
    this.saveWork();
    this.cancelDescriptionEdit();
  }

  public onSummaryChange(name: string): void {
    if (!this.selectedWorkspaceInstanceNode) return;
    this.selectedWorkspaceInstanceNode.name = name;
    this.onChange(name);
    this.formChanged = true;
    if (this.myForm && !this.myForm.form.dirty) {
      this.myForm.form.markAsDirty();
    }
  }

  public onSummaryBlur(name: string): void {
    if (this.oldName !== name) {
      this.saveWork();
    }
  }

  public onTabsValueChange(tabId: string | undefined): void {
    if (!tabId) {
      return;
    }
    this.selectEditPanelTab(tabId as EditPanelTab);
  }

  public get canShowStepsTab(): boolean {
    return !!(this.tableField && this.isTestNode && (!this.isTestStepSelected || !this.isDoView));
  }

  public get canShowRunsTab(): boolean {
    return !!(this.isTestNode && (!this.isTestStepSelected || !this.isDoView));
  }

  public onRunsCountChange(count: number): void {
    this.runsCount = count;
  }

  // public onResizeHandleMouseDown(event: MouseEvent): void {
  //   if (!this.parentPanelElement) return;
  //   this.isPanelResizing = true;
  //   this.resizeStartX = event.clientX;
  //   this.resizeStartWidth = this.panelWidthPx ?? this.panelDefaultWidthPx;
  //   event.preventDefault();
  //   event.stopPropagation();
  //   this.cdr.markForCheck();
  // }

  private isTabAvailable(tabId: EditPanelTab): boolean {
    if (tabId === BluePrintConstants.COMMENTS_TAB) {
      return !(this.isTestStepSelected && this.isDoView);
    }
    if (tabId === BluePrintConstants.STEPS_TAB) {
      return this.canShowStepsTab;
    }
    if (tabId === BluePrintConstants.RUNS_TAB) {
      return this.canShowRunsTab;
    }
    return true;
  }

  // Shows the user's preferred tab whenever the current item/selection can show it, otherwise
  // Overview. Re-run whenever tab availability may have changed (node, test step, view).
  private ensureActiveTabVisibility(): void {
    this.activeTab = this.isTabAvailable(this.preferredTab) ? this.preferredTab : BluePrintConstants.OVERVIEW_TAB;
    if (this.isTestStepSelected && this.isDoView && this.isEditingDescription) {
      this.cancelDescriptionEdit();
    }
  }

  public get nodeStatusLabel(): string {
    const fieldId = this.nodeHelper.getNodeStatusFieldId(this.selectedWorkspaceInstanceNode);
    const currentValue = fieldId ? (this.formData[fieldId] as string) : '';
    const canonicalValue = this.nodeTableHelper.getCanonicalStatusTextForNode(this.selectedNodeViewIntance, currentValue);
    return canonicalValue || currentValue || 'Select';
  }

  public get nodeStatusTooltip(): string {
    const fieldId = this.nodeHelper.getNodeStatusFieldId(this.selectedWorkspaceInstanceNode);
    const statusField = fieldId ? (this.selectedBlueprint?.fields?.find((f) => f.id === fieldId) ?? null) : null;
    return statusField?.tooltip || statusField?.name || '';
  }

  public get nodeStatusChipStyle(): Record<string, string> {
    return this.editPanelUiHelper.buildStatusChipStyle(this.nodeStatusLabel, this.nodeStatusIcons);
  }

  public get stepStatusLabel(): string {
    return this.selectedTestStep?.teststatus || 'Select status';
  }

  public get stepStatusChipStyle(): Record<string, string> {
    return this.editPanelUiHelper.buildStatusChipStyle(this.stepStatusLabel, this.stepStatusIcons);
  }

  // @HostListener('document:mousemove', ['$event'])
  // public onDocumentMouseMove(event: MouseEvent): void {
  //   if (!this.isPanelResizing) return;
  //   let newWidth = this.resizeStartWidth + (this.resizeStartX - event.clientX);
  //   newWidth = this.editPanelUiHelper.clampWidth(newWidth, this.minPanelWidthPx, this.maxPanelWidthPx);
  //   this.panelWidthPx = newWidth;
  //   this.cdr.markForCheck();
  // }

  // @HostListener('document:mouseup')
  // public onDocumentMouseUp(): void {
  //   if (!this.isPanelResizing) return;
  //   this.isPanelResizing = false;
  //   this.cdr.markForCheck();
  // }

  // @HostListener('window:resize')
  // public onWindowResize(): void {
  //   this.updateMaxPanelWidth();
  //   if (this.panelWidthPx && this.panelWidthPx > this.maxPanelWidthPx) {
  //     this.panelWidthPx = this.maxPanelWidthPx;
  //     this.cdr.markForCheck();
  //   }
  // }

  public caseInsensitiveCompare = (a: string, b: string): boolean => this.editPanelUiHelper.caseInsensitiveCompare(a, b);

  private focusSummaryInput(selectAll = false): void {
    setTimeout(() => this.headerComponent?.focusSummary(selectAll));
  }

  private isElementInsideWrapper(element: HTMLElement | null): boolean {
    // If the clicked element is part of an overlay (like a PrimeNG calendar day picker)
    // it may be immediately detached from the DOM upon click before this event handler runs.
    if (element && !element.isConnected) {
      return true;
    }

    while (element) {
      if (
        element.classList &&
        (element.classList.contains('parent-panel') ||
          element.classList.contains('cdk-overlay-container') ||
          element.classList.contains('p-element') ||
          element.classList.contains('p-datepicker') ||
          element.classList.contains('p-connected-overlay'))
      ) {
        return true;
      }
      element = element.parentElement;
    }
    return false;
  }

  private constructUserField(key: string): void {
    // The user field values are the active users assigned to the current project (not the
    // org-wide user directory - that requires user:read, which is admin-only).

    // Read straight off the store rather than this.selectedProject - that local mirror is only
    // synced by loadTargetMaps()/getUpdateJiraIssuePayLoad(), which aren't guaranteed to have run
    // yet for the currently open node. ProjectStore.selectedProject itself is kept current by
    // WorkspaceStore whenever a workspace loads, which must already have happened for any node's
    // edit panel to be open at all.
    const projectId = this.projectStore.selectedProject?.id;
    if (!projectId) {
      this.userList = [];
      this.userListProjectId = null;
      this.setUserFieldOptions(key, this.userList, false, false);
      return;
    }

    // constructFields() (and therefore this) re-runs on every node reload, including the reload
    // that follows every saveWork() - not just on first opening the node/project. Reusing the
    // cached list for the same project avoids a redundant fetch and the "Loading..." flash that
    // would otherwise drop the just-picked assignee from the dropdown after every save.
    if (projectId === this.userListProjectId) {
      this.setUserFieldOptions(key, this.userList, false, false);
      return;
    }

    if (this.subscribers.usersList) {
      this.subscribers.usersList.unsubscribe();
    }

    this.userList = [];
    this.setUserFieldOptions(key, this.userList, true, false);

    this.subscribers.usersList = this.projectService.getProjectMembers(projectId).subscribe({
      next: (members) => {
        const mappedUsers = members && members.length > 0 ? members.map((member) => new UserModel(member)) : [];
        // Catch-admin/system accounts (catchsystemadmin@..., catchexternaladmin@..., the
        // catchcloud service account) must never be assignable - they should not appear in this
        // dropdown regardless of project membership.
        this.userList = this.userDataHelper.removeCatchAdminUsers(mappedUsers);
        this.userListProjectId = projectId;
        this.setUserFieldOptions(key, this.userList);
      },
      // Without this, a failed request (network error, an org/project the actor lost access to,
      // GetProjectMembers not existing on the backend) becomes an unhandled RxJS error and leaves
      // userList/the assignee dropdown showing whatever was there before - stale data from a
      // previously opened node's project, not "no data".
      error: (err: any) => {
        console.log(err);
        this.userList = [];
        this.userListProjectId = null;
        this.setUserFieldOptions(key, this.userList);
      },
    });
  }

  // flushView renders the change immediately. Only the getProjectMembers callbacks may do that:
  // the synchronous callers all run inside constructFields(), which wipes fieldDataArray and
  // testTableFieldIndex before repopulating them. Rendering mid-rebuild evaluates the panel's
  // structural guards against that half-built state - @if (tableField && testTableFieldIndex !==
  // null) goes false and tears down the whole steps pane, destroying the cell PrimeNG is editing
  // and the Quill editor holding the caret. The step table autosaves every cell edit and each
  // save reloads the node, so that lands on every Tab between step cells.
  private setUserFieldOptions(fieldId: string, users: UserModel[], isLoadingOptions = false, flushView = true): void {
    const fieldIndex = this.fieldList.findIndex((field) => field.id === fieldId);
    if (fieldIndex < 0) {
      return;
    }

    const field = this.fieldList[fieldIndex];
    this.fieldList[fieldIndex] = {
      ...field,
      value: {
        ...field.value,
        options: [...users],
        isLoadingOptions,
      },
    };

    this.constructDetailFieldList?.();

    if (!flushView) {
      this.cdr?.markForCheck?.();
      return;
    }

    this.cdr?.detectChanges?.();
  }

  private constructStepDetailsFiled(stepData: ITestStepInstanceModel): void {
    if (stepData) {
      // const inputstepData:ITestStepInstanceModel = this.fieldDataArray.length > 0 ? this.fieldDataArray[3][stepId-1] : stepData
      const stepFieldNameArray: TestStepFieldNames[] = [
        BluePrintConstants.TEST_STEP_DESCRIPTION_FIELD,
        BluePrintConstants.TEST_STEP_EXPECTED_RESULT_FIELD,
        BluePrintConstants.TEST_STEP_ACTUAL_RESULT_FIELD,
        BluePrintConstants.TEST_STEP_DATA_FIELD,
        BluePrintConstants.TEST_STEP_NOTES_FIELD,
      ];
      this.testInputFieldList = stepFieldNameArray.map((fieldName) => ({
        fieldName: fieldName as string,
        value: stepData[fieldName] as string,
      }));
    }
  }

  private constructBugFieldList(): void {
    const bugFieldNames = [BluePrintConstants.STEPS_TO_REPRODUCE_FIELD, BluePrintConstants.ACTUAL_RESULT_FIELD, BluePrintConstants.BUG_RESOLUTION_FIELD, BluePrintConstants.EXPECTED_RESULT_FIELD];
    this.bugFieldList = this.fieldList.filter((listItem) => bugFieldNames.includes(listItem?.name.trim().toLowerCase()));
    // this.fieldList = this.fieldList.filter((listItem) => !bugFieldNames.includes(listItem?.name.trim().toLowerCase()));
  }

  /** True in Backlog for an item that also lives in a local label - see backlog-rollup.helper. */
  public get isBacklogRollupReadOnly(): boolean {
    return BacklogRollupHelper.isNodeRolledUp(this.selectedWorkspace, this.selectedWorkspaceInstanceNode, this.fieldList);
  }

  /**
   * The header status is read-only only when the status field is itself an extended one (Test Status is;
   * Story, Task, Bug, Epic and Page statuses are not and stay editable) - see backlog-rollup.helper.
   */
  public get isBacklogStatusReadOnly(): boolean {
    return BacklogRollupHelper.isFieldReadOnly(this.selectedWorkspace, this.selectedWorkspaceInstanceNode, this.fieldList, this.nodeStatusFieldId);
  }

  private constructDetailFieldList(): void {
    this.detailFieldList = [];
    this.canShowEpicNameField = false;

    if (this.fieldList?.length > 0) {
      const allowEpicField = this.shouldShowEpicField();
      this.canShowEpicNameField = allowEpicField;

      // Fields that should be excluded from detail view
      const excludedFieldNames = [
        BluePrintConstants.BUG_RESOLUTION_FIELD,
        BluePrintConstants.EPIC_NAME_FIELD_LOWER, // Only show if allowEpicField is true
        BluePrintConstants.EXT_APP_REFERENCE_ID_FIELD, // Only show for Jira/Classic ET integrated projects
        BluePrintConstants.STEPS_TO_REPRODUCE_FIELD,
        BluePrintConstants.ACTUAL_RESULT_FIELD,
        BluePrintConstants.EXPECTED_RESULT_FIELD,
        BluePrintConstants.FIELD_TESTING_TABLE_LOWER, // Test steps table
      ];

      // Common editable field types to include in overview (lowercase as stored in DB)
      const editableFieldTypes = [
        'text',
        'number',
        'dropdownsingle',
        'dropdownmultiple',
        'checkbox',
        'date',
        'datetime',
        'memo',
        'radiobuttongroup',
        'formattedtext',
        'url',
        'user', // Target User
      ];

      // Filter and assign valid FieldModels - include all user-defined fields
      this.detailFieldList = this.fieldList.filter((field) => {
        if (!field) return false;

        const fieldNameLower = (field.name || '').toLowerCase().trim();
        const fieldTypeLower = (field.fieldType || '').toLowerCase().trim();
        const normalizedType = fieldTypeLower.startsWith('blueprintfield') ? fieldTypeLower.replace('blueprintfield', '') : fieldTypeLower;

        // Exclude bug-specific fields (they go to bugFieldList)
        if (excludedFieldNames.some((excluded) => fieldNameLower === excluded.toLowerCase())) {
          return false;
        }

        // Exclude the specific status field displayed in the header
        if (this.nodeStatusFieldId && field.id === this.nodeStatusFieldId) {
          return false;
        }

        // Epic name field - only show if allowed
        if (fieldNameLower === BluePrintConstants.EPIC_NAME_FIELD_LOWER && !allowEpicField) {
          return false;
        }

        // Include all common editable field types
        if (editableFieldTypes.includes(normalizedType)) {
          return true;
        }

        // Include any field marked as visible and isExtended (user-defined fields)
        if (field.isVisible && field.isExtended) {
          return true;
        }

        return false;
      });

      if (this.isBacklogRollupReadOnly) {
        this.detailFieldList = BacklogRollupHelper.markExtendedReadOnly(this.detailFieldList);
      }
    }

    // Add Epic Name field back if allowed
    if (this.canShowEpicNameField) {
      const epicNameFields = this.fieldList.filter((field) => field && (field.name || '').toLowerCase() === BluePrintConstants.EPIC_NAME_FIELD_LOWER);
      this.detailFieldList = this.detailFieldList.concat(epicNameFields);
    }

    if (this.jiraHelper.isJiraProject() || this.classicETHelper.isClassicETProject()) {
      const extAppRefFields = this.fieldList.filter((field) => field && (field.name || '').toLowerCase() === BluePrintConstants.EXT_APP_REFERENCE_ID_FIELD);
      this.detailFieldList = this.detailFieldList.concat(extAppRefFields);
    }
  }

  private constructApplyNodeFields(): void {
    if (!this.fieldList || this.fieldList.length === 0) {
      return;
    }

    const matchField = (target: string) =>
      this.fieldList.find((field) => {
        const name = (field?.name || '').toLowerCase().trim();
        const normalizedTarget = target.toLowerCase().trim();
        return name === normalizedTarget || name === `${normalizedTarget}:` || name.includes(normalizedTarget);
      });

    const localNode = matchField(BluePrintConstants.NODETYPE_LOCAL_TARGET_MAPS_FIELD);
    if (localNode) this.localNodeField = localNode;

    const univlNode = matchField(BluePrintConstants.NODETYPE_UNIVL_TARGET_MAPS_FIELD);
    if (univlNode) this.univeralNodeField = univlNode;
  }

  //helper method  that will be moved to service later,
  //read blueprint and get node type name by nodetype id
  // private getSelectedNodeTypeName(): NodeType {
  //   const nodeTypeId = this.selectedWorkspaceInstanceNode?.nodeTypeId;
  //   const nodeTypeName = this.selectedWorkspace?.bluePrint?.nodes?.find((node) => node.id === nodeTypeId)?.name?.toLowerCase();
  //   return <NodeType>nodeTypeName;
  // }

  // private getNodeStatusFieldId(): string | undefined {
  //   if (!this.selectedBlueprint) {
  //     return undefined;
  //   }
  //   const selectedNodeTypeName = this.nodeHelper.getSelectedNodeTypeName(this.selectedWorkspaceInstanceNode);
  //   return this.getFieldIdByName(this.selectedBlueprint, `${selectedNodeTypeName} status`);
  // }

  private initializePanelWidth(): void {
    if (!this.parentPanelElement) return;
    const panel = this.parentPanelElement.nativeElement;
    this.panelDefaultWidthPx = panel.offsetWidth;
    // Always use default width when panel opens
    this.panelWidthPx = Math.max(this.panelDefaultWidthPx, this.minPanelWidthPx);
    this.updateMaxPanelWidth();
  }

  private updateMaxPanelWidth(): void {
    if (!this.parentPanelElement) return;
    this.maxPanelWidthPx = this.dashboardHelper.getRightPanelMaxWidth(this.minPanelWidthPx);
    if (this.panelWidthPx) {
      this.panelWidthPx = this.dashboardHelper.clampRightPanelWidth(this.panelWidthPx, this.minPanelWidthPx);
    }
  }

  private getNodeStatusIcons(): void {
    const selectedNodeTypeName = this.nodeHelper.getSelectedNodeTypeName(this.selectedWorkspaceInstanceNode);
    if (!selectedNodeTypeName || !this.selectedBlueprint) return;

    // 1. Get the status field ID for this node type (e.g., "Epic Status", "Story Status")
    const statusFieldId = this.nodeHelper.getNodeStatusFieldId(this.selectedWorkspaceInstanceNode);
    // console.log('[getNodeStatusIcons] Node type:', selectedNodeTypeName, '| Status field ID:', statusFieldId);

    // 2. Find the status field definition in the blueprint
    const statusField = statusFieldId ? this.selectedBlueprint.fields?.find((f) => f.id === statusFieldId) ?? null : null;

    // if (!statusField) {
    //   console.warn('[getNodeStatusIcons] Status field not found in template for:', selectedNodeTypeName);
    // } else if (!statusField.value?.options) {
    //   console.warn('[getNodeStatusIcons] Status field found but no options defined for:', selectedNodeTypeName);
    // } else {
    //   console.log('[getNodeStatusIcons] Status field options from template:', statusField.value.options);
    // }

    // 3. Find the blueprint node to access PropertyBinding for colors
    const blueprintNode = this.selectedBlueprint.nodes?.find((n) => n.id === this.selectedWorkspaceInstanceNode.nodeTypeId);

    // 4. Build dynamic status icons from blueprint
    this.nodeStatusIcons = this.blueprintPropertyBindingHelper.buildStatusIconsFromBlueprint(statusField, blueprintNode?.propertyBinding, statusFieldId || '', selectedNodeTypeName);

    // console.log('[getNodeStatusIcons] Loaded from template, count:', this.nodeStatusIcons.length);

    // 5. If no status is currently set, default to the first available status
    if (this.nodeStatusIcons.length > 0 && statusFieldId) {
      const currentValue = this.formData[statusFieldId] as string;
      // Defaulting writes the status field, so it must not run for a status Backlog shows from another label.
      if (!currentValue && !this.isBacklogStatusReadOnly) {
        const statusAlt = this.nodeStatusIcons[0]?.alt;
        if (statusAlt) {
          this.onChangeNodeStatus(statusAlt, false);
        }
      }
    }
  }

  private getStepStatusIcons(): void {
    const testStatusField = this.editPanelTestStepHelper.getTestStatusField(this.selectedWorkspace);
    const testNodeTypeName = this.testNodeType?.name || BluePrintConstants.TEST_NODE_LOWER;
    const config = this.editPanelTestStepHelper.buildTestStatusConfig(this.selectedWorkspace);
    this.stepStatusIcons = this.blueprintPropertyBindingHelper
      .buildStatusIconsFromBlueprint(testStatusField, null, testStatusField?.id || '', testNodeTypeName)
      .filter((iconObj) => iconObj.key !== config.inProgressLower);
  }

  public onNavigationClicked(direction: NavigationDirections, toBeSaved = false): void {
    const navigationFun = (): void => {
      if (this.isTestStepSelected && this.isDoView) {
        this.navigateWithinTestSteps(direction);
      } else {
        this.navigateWithinNode(direction);
      }
    };
    // A test-step cell that is still open has not been promoted into the save payload yet: the
    // rich-text cell writes each keystroke straight into the step object in fieldDataArray, but
    // fieldTableDataArray/formData (what getFieldsDataEnocded/getFormFieldsData actually read) are
    // only synced when PrimeNG completes the edit — and that completion runs off the document-click
    // listener, i.e. AFTER this handler has already navigated. hasUnsavedWork() spots it so the save
    // below runs while selectedWorkspaceInstanceNode is still the node the user was editing - the
    // pending work is written to THIS node instead of following them to the next one (ZOO-10027).
    if (this.hasUnsavedWork() || toBeSaved) {
      this.saveWork(true, false, navigationFun.bind(this));
    } else {
      navigationFun();
    }
  }

  // Everything that means "the panel is holding work the server does not have yet". Shared by every
  // action that leaves the current context - node navigation, test-step navigation, tab switching -
  // so they cannot drift apart on what counts as unsaved.
  //
  // Deliberately not myForm.dirty/touched: every field handler saves immediately, and those flags
  // stick without any real change (opening a step cell - OnTableEditActivate - marks the form dirty,
  // focusing then leaving a field marks it touched, and saveWork never marks it untouched), so they
  // turned a plain tab switch into a patch call.
  private hasUnsavedWork(): boolean {
    return this.formChanged || this.hasUnsavedTestStepEdits();
  }

  // True when the step table on screen differs from what was last loaded or saved. The open
  // rich-text cell writes every keystroke straight into the step array, but PrimeNG only reports the
  // edit via its document-click completion - which fires after the nav handler has already run - so
  // comparing against the committed snapshot is the only way to know, at nav time, that there is
  // work to save (ZOO-10027).
  private hasUnsavedTestStepEdits(): boolean {
    const liveTableData = this.getTableData(this.fieldDataArray);
    if (!this.tableField?.id || !Array.isArray(liveTableData) || this.committedStepsJson === null) {
      return false;
    }
    return JSON.stringify(liveTableData) !== this.committedStepsJson;
  }

  // Promotes the step table the panel is actually showing into the structures the save payload is
  // built from, and records it as the new committed baseline.
  //
  // fieldDataArray[n] is the live array: the open cell mutates it in place, and onAddTestStep
  // replaces it outright (addStep returns a new array). fieldTableDataArray - which
  // getFieldsDataEnocded() serialises - starts out aliased to that same array (constructTableField
  // assigns one reference to all three of fieldTableDataArray/formData/fieldDataArray) but stops
  // being so the moment either side is reassigned. Re-deriving at save time means every mutation
  // path reaches the payload whichever one it was, instead of each caller having to remember to
  // mirror its change into three places.
  private syncStepTableIntoPayload(tableData: any[] | undefined): void {
    const fieldId = this.tableField?.id;
    if (!fieldId || !Array.isArray(tableData)) {
      return;
    }
    this.fieldTableDataArray[fieldId] = this.helperService.getDeepCopy(tableData);
    this.formData[fieldId] = JSON.stringify(tableData);
    this.numberOfTestSteps = tableData.length;
    this.committedStepsJson = JSON.stringify(tableData);
  }

  private navigateWithinNode(direction: NavigationDirections): void {
    const visibleNodes = this.getVisibleNodesList();

    if (visibleNodes && visibleNodes.length > 0) {
      this.navigateWithinVisibleNodes(direction, visibleNodes);
    } else {
      if (direction.toLocaleLowerCase() === AppConstants.NAVIGATION_DIRECTION_PREVIOUS) {
        this.workspaceStore.selectPreviousNode();
      } else if (direction.toLocaleLowerCase() === AppConstants.NAVIGATION_DIRECTION_NEXT) {
        this.workspaceStore.selectNextNode();
      }
    }
  }

  private getVisibleNodesList(): INodeInstanceViewModel[] | null {
    const navigationList = this.workspaceStore?.navigationNodeList;
    if (navigationList && navigationList.length > 0) {
      return navigationList;
    }

    const allNodes = this.workspaceStore?.nodeInstanceViewModelList;
    if (!allNodes || allNodes.length === 0) return null;

    const isAllExpanded = this.toolbarEventManagerHelper?.DoToolbarIsAllExpanded ?? true;

    if (isAllExpanded) {
      return allNodes;
    }

    const childNodeIds = new Set<string>();
    allNodes.forEach((node) => node?.childNodes?.forEach((child) => child?.id && childNodeIds.add(child.id)));

    return allNodes.filter((node) => node?.id && !childNodeIds.has(node.id));
  }

  private navigateWithinVisibleNodes(direction: NavigationDirections, visibleNodes: INodeInstanceViewModel[]): void {
    const currentNode = this.selectedWorkspaceInstanceNode;
    if (!currentNode?.id) return;

    const currentIndex = visibleNodes.findIndex((n) => n?.id === currentNode.id);
    if (currentIndex === -1) {
      if (visibleNodes.length > 0 && visibleNodes[0]) {
        this.workspaceStore.selectedWSINode = visibleNodes[0];
      }
      return;
    }

    let newIndex: number;
    if (direction.toLocaleLowerCase() === AppConstants.NAVIGATION_DIRECTION_PREVIOUS) {
      newIndex = currentIndex > 0 ? currentIndex - 1 : visibleNodes.length - 1;
    } else {
      newIndex = currentIndex < visibleNodes.length - 1 ? currentIndex + 1 : 0;
    }

    if (visibleNodes[newIndex]) {
      this.workspaceStore.selectedWSINode = visibleNodes[newIndex];
    }
  }

  private navigateWithinTestSteps(direction: NavigationDirections): void {
    const currentStep = this.workspaceStore.selectedTestStep;
    if (!currentStep) return;
    if (direction.toLocaleLowerCase() === AppConstants.NAVIGATION_DIRECTION_NEXT) {
      this.workspaceStore.selectedTestStep = this.testStepNavigationHelper.getNextStep(currentStep.stepId);
    } else if (direction.toLocaleLowerCase() === AppConstants.NAVIGATION_DIRECTION_PREVIOUS) {
      this.workspaceStore.selectedTestStep = this.testStepNavigationHelper.getPreviousStep(currentStep.stepId);
    }
  }
  public onChangeNodeStatus(statusValue: string, shouldSave: boolean = true): void {
    if (!statusValue || !this.selectedNodeViewIntance || !this.selectedWorkspaceInstanceNode || this.isBacklogStatusReadOnly) {
      return;
    }

    const canonicalStatusId = this.nodeTableHelper.getCanonicalStatusIdForNode(this.selectedNodeViewIntance, statusValue);
    const statusFieldId = this.nodeHelper.getNodeStatusFieldId(this.selectedWorkspaceInstanceNode);
    if (statusFieldId) {
      this.formData[statusFieldId] = canonicalStatusId;
      if (this.selectedWorkspaceInstanceNode?.fields) {
        this.selectedWorkspaceInstanceNode.fields[statusFieldId] = canonicalStatusId;
      }
    }
    const selectedNodeTypeName = this.nodeHelper.getSelectedNodeTypeName(this.selectedWorkspaceInstanceNode);

    if (selectedNodeTypeName && selectedNodeTypeName.toLowerCase() === BluePrintConstants.TEST_NODE_LOWER) {
      // statusChangeHandler downstream still operates on text (lowercase compares to 'done' etc.) —
      // resolve to text before handing off so the test-step sync still matches.
      const statusText = this.nodeTableHelper.getCanonicalStatusTextForNode(this.selectedNodeViewIntance, canonicalStatusId);
      this.statusChangeHandler(statusText);
    }

    //ZOO-8530 : shut down this feature but will keep code for a while if we decided to reopen it
    // if (
    //   statusValue.toLowerCase() === AppConstants.NODE_STATUS_BLOCKED_LOWER ||
    //   statusValue.toLowerCase() === AppConstants.NODE_STATUS_FAILED_LOWER ||
    //   statusValue.toLowerCase() === AppConstants.NODE_STATUS_PASSED_LOWER ||
    //   statusValue.toLowerCase() === AppConstants.NODE_STATUS_DONE_LOWER
    // ) {
    //   this.saveWork(true, false, this.navigateToNext.bind(this));
    // } else {
    if (shouldSave) {
      this.saveWork();
    }
    //}
  }

  private navigateToNext(): void {
    this.navigateWithinNode(AppConstants.NAVIGATION_DIRECTION_NEXT);
  }

  public onChangeStepStatus(statusValue: string): void {
    if (this.isBacklogRollupReadOnly) return;
    if (!this.fieldDataArray || !this.selectedTestStep || this.selectedTestStep.id === undefined) return;

    const stepIndex = this.selectedTestStep.id - 1;
    if (this.fieldDataArray[3] && this.fieldDataArray[3][stepIndex]) {
      this.fieldDataArray[3][stepIndex].teststatus = statusValue;
    }

    // Update the status on the selectedTestStep
    this.selectedTestStep.teststatus = statusValue;
    this.updateTestStatusFromSteps(this.fieldDataArray[3]);
    this.saveWork();
  }

  public hasTable(fieldList: any): boolean {
    return fieldList?.some((field: any) => field.fieldType.toLowerCase() === 'table');
  }

  public getTableData(fieldData: any[]): any[] | undefined {
    return fieldData?.find((fd) => Array.isArray(fd) && fd?.[0] && typeof fd[0] === 'object' && 'teststatus' in fd[0]);
  }

  // The expand / collapse tab lives on the dashboard's right panel, not in this header, so it is told
  // whether this panel can be widened: only while an item is open and the toolbar is not hidden.
  private edgeToggleVisible = false;
  private destroyed = false;

  ngDoCheck(): void {
    const visible = !!this.selectedWorkspaceInstanceNode && !this.hideNavigation;
    if (visible !== this.edgeToggleVisible) {
      this.edgeToggleVisible = visible;
      // Deferred a tick: this runs mid change-detection, and the toggle it drives is bound to the value
      // through an async pipe that has already been checked this pass.
      // The destroyed guard stops a write queued before teardown from re-registering a panel that is gone.
      Promise.resolve().then(() => {
        if (!this.destroyed) {
          this.dashboardHelper.setPanelEdgeToggleVisible(this, visible);
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    this.dashboardHelper.setPanelEdgeToggleVisible(this, false);
    super.ngOnDestroy();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.initializePanelWidth();
      this.subscribers.rightHandPanelExpand = this.dashboardHelper.isRightPanelExpanded.subscribe((res: any) => {
        if (res !== undefined && res !== null) {
          this.testStepDataTableActive = res;
          this.isEditPanelExpanded = res;
          // When panel expands, increase width slightly if it's at default
          if (res === true && (this.panelWidthPx ?? 0) <= this.panelDefaultWidthPx) {
            const targetWidth = this.panelDefaultWidthPx + 200;
            this.panelWidthPx = Math.min(this.maxPanelWidthPx || this.panelDefaultWidthPx, Math.max(targetWidth, this.panelDefaultWidthPx));
          }
          this.cdr.markForCheck();
        }
      });

      this.subscribers.attachments = this.attachmentStore.$attachments.subscribe((atts) => {
        if (atts) {
          this.attachmentsOrg = atts;
        }
      });

      this.subscribers.selectedTestStep = this.workspaceStore.$selectedTestStep.subscribe((x) => {
        if (x) {
          this.isTestStepSelected = true;
          this.selectedTestStep = x;
          this.constructStepDetailsFiled(x);
        } else {
          this.isTestStepSelected = false;
        }
        this.ensureActiveTabVisibility();
        this.cdr.detectChanges();
        setTimeout(() => this.loadInitialData());
      });

      this.subscribers.rightPanelVisible = this.dashboardHelper.$showRightPanel.subscribe((panelVisibility: boolean) => {
        if (panelVisibility === false) {
          // If right side panel is closed without saving then reset to previous value
          if (this.selectedWorkspace?.nodeInstances && this.selectedWorkspaceInstanceNodeOldVal) {
            const oldNode = this.selectedWorkspace.nodeInstances.find((n) => n?.id === this.selectedWorkspaceInstanceNodeOldVal?.id);
            if (oldNode) {
              // Need to update the attachment References
              this.selectedWorkspaceInstanceNodeOldVal.attachmentReferences = this.selectedNodeViewIntance?.attachmentReferences ?? [];
              this.selectedWorkspace.nodeInstances[this.selectedWorkspace.nodeInstances.indexOf(oldNode)] = this.selectedWorkspaceInstanceNodeOldVal;
            }
            if ((this.myForm && this.myForm.form.dirty && this.myForm.form.valid) || this.formChanged) {
              this.myForm.form.markAsPristine();

              this.dashboardHelper.setModifiedPropertyItem({
                id: this.selectedWorkspaceInstanceNodeOldVal.id,
                name: this.selectedWorkspaceInstanceNodeOldVal.name,
                description: this.selectedWorkspaceInstanceNodeOldVal.description,
              });
            }
          }
          this._wasRightPanelVisible = false;
        } else {
          // Only focus the summary/name field when the panel is freshly opening
          // (i.e. transitioning from hidden to visible). Suppressing this on every
          // subsequent true-emission prevents focus from jumping back to the Item
          // Name field while the user is editing other fields (ZOO-9298).
          if (!this._wasRightPanelVisible) {
            this.focusSummaryInput(true);
          }
          this._wasRightPanelVisible = true;
        }
      });

      this.subscribers.selectedItemChanged = this.dashboardHelper.selectedItem.subscribe((result) => {
        if (this.selectedWorkspaceInstanceNode && !this.selectedWorkspaceInstanceNode.locked && this.selectedWorkspaceInstanceNode.id !== this.lastLoadedNodeId) {
          // The $selectedWSINode path is authoritative; only load here when it has not already loaded this node.
          setTimeout(() => this.loadInitialData());
        }
      });

      this.subscribers.currentMainView = this.dashboardHelper.$mainView.subscribe((res: any) => {
        if (res) {
          if (res === AppConstants.CATCH_INTERNAL_APP_DOVIEW_LOWER) {
            this.isDoView = true;
            this.ensureActiveTabVisibility();
            return;
          }
          this.isDoView = false;
          this.ensureActiveTabVisibility();
        }
      });

      this.subscribers.selectedWSINode = this.workspaceStore.$selectedWSINode.subscribe((res: any) => {
        if (res) {
          if (!this.selectedWorkspace) {
            //this.selectedWorkspace = this.workspaceFactory.createWorkspaceInstanceModelFromobject(this.workspaceStore.selectedWorkspaceInstance);
            this.selectedWorkspace = this.workspaceStore.selectedWorkspaceInstance;
          }

          // The active tab is deliberately kept across a node change - constructFields() re-checks
          // it against the new node's type once its fields are known.
          const isNodeChanged = this.selectedWorkspaceInstanceNode?.id !== res.id;
          this.selectedWorkspaceInstanceNode = res;
          this.lastLoadedNodeId = res.id;
          this.oldName = res.name;
          this.formData = this.editPanelDataHelper.buildFormData(this.fieldList, this.selectedWorkspaceInstanceNode);
          //update the selected node in nodeInstanceViewModelList was missing
          const selectedNode = this.nodeInstanceViewModelList?.find((node) => node.id === this.selectedWorkspaceInstanceNode?.id);
          if (selectedNode) {
            this.selectedNodeViewIntance = selectedNode;
          }

          // }
          this.getChildNodeNameList();
          this.updateGenerateTestsAvailability();
          setTimeout(() => {
            this.loadInitialData();
            if (this.myForm?.form) {
              this.myForm.form.markAsPristine();
              this.myForm.form.markAsUntouched();
            }
            this.formChanged = false;
            if (isNodeChanged) {
              this.focusSummaryInput(true);
            }
          });
        } else {
          this.selectedWorkspaceInstanceNode = null as any;
          this.updateGenerateTestsAvailability();
        }
      });

      this.subscribers.selectedWorkspaceInstance = this.workspaceStore.$selectedWorkspaceInstance.subscribe((res: any) => {
        if (res) {
          this.dashboardHelper.setSharedRightPanelHeaderVisible(false);
          this.selectedWorkspace = res;
          this.dueDateFieldId = this.blueprintDataHelper.getFieldDueDate()?.id || '';
          this.startDateFieldId = this.blueprintDataHelper.getFieldStartDate()?.id || '';
          if (this.selectedWorkspaceInstanceNode && this.fieldList.length === 0) {
            setTimeout(() => this.loadInitialData());
          }
        }
      });

      this.subscribers.nodeInstanceViewModelList = this.workspaceStore.$nodeInstanceViewModelList.subscribe((nodeInstanceViewModelArray: INodeInstanceViewModel[] | null) => {
        if (nodeInstanceViewModelArray) {
          this.nodeInstanceViewModelList = nodeInstanceViewModelArray;

          if (this.selectedWorkspaceInstanceNode && this.nodeInstanceViewModelList && this.nodeInstanceViewModelList?.length > 0) {
            const selectedNode = this.nodeInstanceViewModelList.find((node) => node.id === this.selectedWorkspaceInstanceNode?.id);
            if (selectedNode) this.selectedNodeViewIntance = selectedNode;
            if (selectedNode && selectedNode.testSteps && selectedNode.testSteps?.length > 0) {
              //this is dirty way of identifing is user current action is "test step adding"
              // we need to think how we will manage events in future
              //jay
              this.testStepNavigationHelper.setSteps(selectedNode.testSteps);
              if (this.isAddingTestStep) {
                this.isAddingTestStep = false;
                this.isTestStepSelected = true;
                this.workspaceStore.selectedTestStep = selectedNode.testSteps[selectedNode.testSteps?.length - 1];
              }
            }
          }
          this.workspaceDataHelper.extractTestStepAttachments(this.nodeInstanceViewModelList, this.attachmentsOrg);
        }
      });

      this.subscribers.myUserInfo = this.userStore.$myUserInfo.subscribe((res: any) => {
        if (res) {
          setTimeout(() => this.loadInitialData());
        }
      });

      this.subscribers.focusElement = this.eventManager.$focusElement.subscribe((focusEvent: ISetFocusEvent | null) => {
        //Need to set delay for InputNativeElement to be available, otherwise it will be null.
        setTimeout(() => {
          if (focusEvent && focusEvent.tagetModuleList.includes(AppModuleName.EditPanelModule)) {
            if (focusEvent.webElement === WebElementName.EditPanelTestStepStepDescription) {
              this.detailsPaneComponent?.focusTestStepDetails();
            }
            if (focusEvent.webElement === WebElementName.EditPanelSummary) {
              // Don't pull focus to the name field while editing the step table;
              // autosave re-selects the node and would yank focus out of the cell.
              if (this.activeTab?.toLowerCase() === BluePrintConstants.STEPS_TAB && this.testStepDataTableActive) {
                return;
              }
              if (this.isTestStepSelected && this.isDoView && this.detailsPaneComponent) {
                this.detailsPaneComponent.focusTestStepDetails();
                return;
              }
              this.headerComponent?.focusSummary(true);
            }
          }
        });
      });

      this.subscribers.highElement = this.eventManager.$highlightElement.subscribe((highElement: ISetFocusEvent | null) => {
        setTimeout(() => {
          if (highElement && highElement.tagetModuleList.includes(AppModuleName.EditPanelModule)) {
            if (highElement.webElement === WebElementName.EditPanelSummary) {
              this.headerComponent?.focusSummary(true);
            }
          }
        });
      });

      this.subscribers.comments = this.commentStore.$comments.subscribe((comments: List<CommentModel>) => {
        if (this.selectedWorkspaceInstanceNode && comments) {
          const commentModel = comments.find((c) => c?.workspaceId === this.selectedWorkspace?.id && c?.nodeId === this.selectedWorkspaceInstanceNode?.id);
          if (commentModel && commentModel.nodeComments) {
            this.selectedWorkspaceInstanceNode.comments = commentModel.nodeComments.map((nc) => nc?.id).filter((id) => id !== null && id !== undefined);
            this.cdr.markForCheck();
          }
        }
      });

      // Subscribe to blueprint changes to refresh field list when new fields are added
      this.subscribers.blueprintChanges = this.blueprintStore.$selectedBluePrint.subscribe((blueprint) => {
        if (blueprint && this.selectedWorkspace && blueprint.id === this.selectedWorkspace.bluePrintId && this.selectedWorkspaceInstanceNode) {
          // Blueprint updated - refresh the field list and references
          this.selectedBlueprint = blueprint;
          this.applyBlueprintFieldReferences();
          this.constructFields();
          this.formData = this.editPanelDataHelper.buildFormData(this.fieldList, this.selectedWorkspaceInstanceNode);
          this.applyEpicNameDisplayDefault();
          this.getNodeStatusIcons();
          this.getStepStatusIcons();
          this.updateGenerateTestsAvailability();
          this.cdr.detectChanges();
        }
      });
    });

    this.subscribers.saveWorkEvent = this.eventManager.$saveWorkEvent.subscribe((saveWorkEvent: ISaveWorkEventModel | null) => {
      if (saveWorkEvent && saveWorkEvent.eventFired) {
        const afterSaveCallback = () => {
          this.dashboardHelper.setShowRightPanel(!saveWorkEvent.closeEditPanel);
        };
        if ((this.myForm?.form.dirty && this.myForm?.form.touched) || this.formChanged) {
          this.saveWork(false, true, afterSaveCallback.bind(this), false);
        } else {
          if (saveWorkEvent.closeEditPanel) {
            this.dashboardHelper.setShowRightPanel(false);
          }
        }
      }
    });
    //this.setNameFieldAsFocus();
  }

  loadInitialData() {
    if (!this.selectedWorkspaceInstanceNode || !this.selectedWorkspace) {
      return;
    }
    this.selectedBlueprint = this.blueprintStore.getBlueprintByIdFromCache(this.selectedWorkspace.bluePrintId);
    if (!this.blueprintStore.isBlueprintHydrated(this.selectedBlueprint)) {
      this.blueprintStore.ensureBlueprintLoaded(this.selectedWorkspace.bluePrintId);
      return;
    }
    this.isEditingDescription = false;
    this.descriptionDraft = '';

    // this.loggerService.traceInfo(this.className, this.loadInitialData.name, 'combinedresult', '', this.selectedWorkspaceInstanceNode);
    //console.log(this.selectedWorkspace);
    this.locked = this.selectedWorkspaceInstanceNode ? this.selectedWorkspaceInstanceNode.locked : false;
    // console.log(selectedNode);
    // this.oldNodeVal = this.nodeFactory.createNodeInstanceFromObject(this.helperService.getDeepCopy(this.selectedWorkspaceInstanceNode));
    // Name and description are NOT decoded on the way in. sanitize() is the other half of
    // esc(), and only the test-step table is ever encoded with it - getFieldsDataEnocded()
    // runs esc() over the step rows on save, sanitizeJson() reverses it on load. These two
    // are stored exactly as the editor produced them, so decoding them here had no matching
    // encode: it turned '&lt;' (how Quill stores a '<' the user typed) into real markup,
    // which Quill then discarded on the next load. Typing "<test>" in a description saved
    // fine and came back empty; "<b>x</b>" came back as actual bold text.
    this.selectedWorkspaceInstanceNode.description = flattenListRowBlocks(this.selectedWorkspaceInstanceNode.description);
    this.selectedWorkspaceInstanceNodeOldVal = this.helperService.getDeepCopy(this.selectedWorkspaceInstanceNode);

    this.bugNodeType = this.selectedBlueprint.nodes.find((bpn) => bpn.name.toLocaleLowerCase() === BluePrintConstants.BUG_NODE_LOWER) || null;
    this.extRefField = this.selectedBlueprint.fields.find((bpf) => bpf.name.toLocaleLowerCase() === BluePrintConstants.EXT_APP_REFERENCE_ID_FIELD) || null;
    this.assignedToField = this.selectedBlueprint.fields.find((bpf) => bpf.name.toLocaleLowerCase() === BluePrintConstants.ASSIGNED_TO_FIELD) || null;
    this.testStatusField =
      this.selectedBlueprint.fields.find(
        (bf) => bf.name.toLocaleLowerCase() === BluePrintConstants.TEST_STATUS_FIELD_LOWER && bf.fieldType.toLocaleLowerCase() === BluePrintConstants.INPUT_TYPE_DROPDOWN_SINGLE,
      ) || null;
    this.testNodeType = this.selectedBlueprint.nodes.find((bn) => bn.name.toLocaleLowerCase() === BluePrintConstants.TEST_NODE_LOWER) || null;
    //format due date format for display:
    //this.initializeDate();
    //this.initializeDateField();

    this.testStepsField = this.selectedBlueprint.fields.find((f) => f.name.toLocaleLowerCase().trim() === BluePrintConstants.FIELD_TESTING_TABLE_LOWER) || null;
    this.applyBlueprintFieldReferences();

    // the name is saved as old name now if user clears it, reuse it from here
    this.formChanged = false;
    this.loadTargetMaps(); // load all map names in collection except current one inside the project
    this.constructFields();

    this.formData = this.editPanelDataHelper.buildFormData(this.fieldList, this.selectedWorkspaceInstanceNode);
    this.applyEpicNameDisplayDefault();

    this.getNodeStatusIcons();
    this.getStepStatusIcons();

    if (this.selectedWorkspaceInstanceNode) {
      this.oldName = this.selectedWorkspaceInstanceNode.name;
    }

    this.cdr.detectChanges();
  }

  /**
   * Shows the Epic Name field pre-filled with the node's own Name, editable from there rather
   * than from scratch - the same convenience the old constructFields mutation gave, but applied
   * to formData (display) instead of selectedWorkspaceInstanceNode.fields (what gets saved).
   * getFieldsDataEnocded strips this default back out at save time unless the user actually
   * changed it - see isUnconfirmedEpicNameDefault - so leaving it untouched never persists it.
   */
  private applyEpicNameDisplayDefault(): void {
    if (!this.epicNameField || !this.formData || !this.selectedWorkspaceInstanceNode) {
      return;
    }
    if (!this.formData[this.epicNameField.id]) {
      this.formData[this.epicNameField.id] = this.selectedWorkspaceInstanceNode.name;
      this.epicNameDisplayDefault = this.selectedWorkspaceInstanceNode.name;
    } else {
      this.epicNameDisplayDefault = null;
    }
  }

  /**
   * True when `fieldId` is the Epic Name field, nothing was ever persisted there, and formData
   * still reads exactly as applyEpicNameDisplayDefault left it - i.e. the user never actually
   * edited the field, they just saved something else while the cosmetic default sat there
   * unconfirmed. Compares against selectedWorkspaceInstanceNodeOldVal (the last known persisted
   * state) rather than selectedWorkspaceInstanceNode.fields, which a same-session edit may
   * already have moved.
   *
   * A user who deliberately retypes the exact same text the default already showed is treated
   * the same as one who left it alone - both read as "Epic Name left as the node's own name",
   * which is already how an unset Epic Name resolves everywhere else it's read (e.g.
   * getUpdateJiraIssuePayLoad's `? value : name` fallback), so nothing is lost by not persisting it.
   */
  private isUnconfirmedEpicNameDefault(fieldId: string): boolean {
    if (!this.epicNameField || fieldId !== this.epicNameField.id) {
      return false;
    }
    const persisted = this.selectedWorkspaceInstanceNodeOldVal?.fields?.[fieldId];
    if (persisted) {
      return false;
    }
    // Compare against the default that was actually displayed, not the node's current name:
    // onSummaryChange overwrites selectedWorkspaceInstanceNode.name on every keystroke, so after
    // the user renames the node the box still holds the OLD name and a name comparison would
    // read it as a deliberate Epic Name edit and persist it.
    const shownDefault = (this.epicNameDisplayDefault || '').trim();
    if (!shownDefault) {
      return false;
    }
    const current = this.formData[fieldId];
    return typeof current === 'string' && current.trim() === shownDefault;
  }

  private applyBlueprintFieldReferences(): void {
    const refs = this.editPanelDataHelper.loadBlueprintFieldReferences(this.selectedWorkspace);
    this.bugNodeType = refs.bugNodeType;
    this.storyNodeType = refs.storyNodeType;
    this.epicNodeType = refs.epicNodeType;
    this.taskNodeType = refs.taskNodeType;
    this.subTaskNodeType = refs.subTaskNodeType;
    this.epicNameField = refs.epicNameField;
    this.extRefField = refs.extRefField;
  }

  private shouldShowEpicField(): boolean {
    if (!this.selectedWorkspaceInstanceNode?.nodeTypeId || !this.epicNodeType?.id) {
      return false;
    }
    return this.selectedWorkspaceInstanceNode.nodeTypeId === this.epicNodeType.id;
  }

  private closeAfterSaveWork(): void {
    this.dashboardHelper.setShowRightPanel(false);
    this.dashboardHelper.setExpandRightPanel(false);
    this.dashboardHelper.setRightPanelWidthPx(null);
    // Only on the user's explicit close - not in setShowRightPanel(false) itself, which also fires on
    // route changes where catch-hub-dashboard restores the panel (and its selected node) afterwards.
    this.workspaceStore.clearNodeSelection();
  }

  public onClickCloseRightPanel(): void {
    if ((this.myForm.form.dirty && this.myForm.form.touched) || this.formChanged) {
      this.saveWork(true, false, this.closeAfterSaveWork.bind(this));
    } else if (this.subscribers.patchWSINode && !this.subscribers.patchWSINode.closed) {
      // A save is still in flight (e.g. summary blur fired its own saveWork() just before this
      // click) — that save already cleared the dirty/formChanged flags above synchronously, before
      // its PATCH resolved. Closing now would destroy this component, and BaseComponent's
      // ngOnDestroy unsubscribes every entry in `subscribers`, which would abort that in-flight
      // PATCH client-side and silently drop the change. Queue the close for when it completes.
      this.pendingSaveCallback = this.closeAfterSaveWork.bind(this);
    } else {
      this.closeAfterSaveWork();
    }
  }

  onExpandTestTable(value: boolean) {
    this.dashboardHelper.setExpandRightPanel(value);
  }

  getNodesTreePathById(nodesTree: any, idString: string) {
    if (!nodesTree) return;
    let resultPath = '';
    //helper function to reset to previous path if current node +esn't contain the target id
    const getPreviousPath = (pathString: string) => {
      let pathArr = pathString?.split('/');
      return pathArr?.slice(0, pathArr?.length - 1).join('/');
    };

    let path = '';
    // utility recursive function to search through nodeTree with the node id
    const getNodePathById = (node: any) => {
      path = path + '/' + node.name;
      if (node.id === idString) {
        resultPath = path.slice(1);
        return;
      }
      if (node.children?.length > 0) {
        node.children.forEach((childNode: any) => {
          getNodePathById(childNode);
          path = getPreviousPath(path);
        });
      }
    };
    nodesTree.forEach((nodeEle: any) => {
      path = '';
      getNodePathById(nodeEle);
    });
    return resultPath;
  }

  private getLabelNameById(nodesTreeList: ITreeNode[] | null, id: string): string {
    if (!nodesTreeList) return '';

    for (let index = 0; index < nodesTreeList?.length; index++) {
      const node: any = nodesTreeList[index];

      if (node.id === id) {
        return node.name;
      } else if (node.children?.length > 0) {
        var lable = this.getLabelNameById(node.children, id);
        if (lable) {
          return lable;
        }
      }
    }
    return '';
  }

  loadTargetMaps() {
    // console.log("loadTargetMaps");
    this.allTargetMapsLocal = [];
    this.allTargetMapsUnivl = [];
    this.allTargetMapsAny = [];
    // if (!this.selectedProject) {
    this.selectedProject = this.projectStore?.selectedProject;
    if (!this.selectedProject) {
      return;
    }
    // console.log('selected project');
    // console.log(this.selectedProject);
    this.selectedProject.mappedEntities.forEach((me) => {
      if (me && me.type && me.type.toLowerCase() === 'map') {
        // if (me.id === this.selectedWorkspace.id) {
        //   return;
        // }
        me.path = this.getNodesTreePathById(this.selectedProject?.treeNodes, me.id) || '';
        //let targetNode:any = this.selectedProject.treeNodes.find((treeNode:any) => treeNode.id === me.id);

        // Archived maps are pruned from treeNodes, so fall back to the entity's own name
        // rather than overwriting it with an empty lookup result.
        let targetNode: any = this.getLabelNameById(this.selectedProject?.treeNodes || null, me.id);
        me.name = targetNode || me.name;
        this.allTargetMapsAny.push(me);
        if (me.isArchived === false) {
          this.allTargetMapsUnivl.push(me);
          this.allTargetMapsLocal.push(me);
        }
      }
    });
    // this.selectedProject.mappedPackages.forEach(mp => {
    //   mp.mappedEntities.forEach(me => {
    //     if (me.type === 'map' && me.isArchived === false) {
    //       // if (me.id === this.selectedWorkspace.id) {
    //       //   return;
    //       // }
    //       me.path = this.getNodesTreePathById(this.selectedWorkspace.selectedProject.treeNodes,me.id);
    //       this.allTargetMapsUnivl.push(me);
    //       this.allTargetMapsLocal.push(me);
    //     }
    //   });
    //   mp.children.forEach(mpChild => {
    //     this.loadTargetChildMaps(mpChild);
    //   });
    // });
    // }
    // console.log('all target Maps Universal');
    // console.log(this.allTargetMapsUnivl);
  }

  loadTargetChildMaps(mappedPackage: IMappedEntityModel) {
    if (!mappedPackage || !mappedPackage.children) {
      return;
    }
    mappedPackage.children.forEach((mp) => {
      if (mp.type === 'map') {
        this.allTargetMapsUnivl.push(mp);
        this.allTargetMapsLocal.push(mp);
      }
    });
  }

  logCurrentStatus(funcName: string) {
    // console.log('Method::' + funcName);
    // console.log('this.targetMapsUnivlSelected');
    // console.log(this.targetMapsUnivlSelected);
    // console.log('this.targetMapsLocalSelected');
    // console.log(this.targetMapsLocalSelected);
    // console.log('this.allTargetMapsUnivl');
    // console.log(this.allTargetMapsUnivl);
    // console.log('this.allTargetMapsLocal');
    // console.log(this.allTargetMapsLocal);
    // // console.log('filteredTargetMapsLocal');
    // console.log(this.filteredTargetMapsLocal.)
  }

  private persistTargetMapSelection(fieldName: string, selectedMaps: IMappedEntityModel[]): void {
    this.editPanelTargetMapHelper.persistSelection({
      selectedWorkspace: this.selectedWorkspace,
      selectedNode: this.selectedWorkspaceInstanceNode,
      formData: this.formData,
      fieldName,
      selectedMaps,
    });
  }

  private updateTestStatusFromSteps(tableData: any[]): void {
    if (!this.testStatusField?.id) {
      return;
    }
    const aggregateStatus = this.editPanelTestStepHelper.calculateAggregateStatus(tableData, this.editPanelTestStepHelper.buildTestStatusConfig(this.selectedWorkspace));
    if (!aggregateStatus) {
      return;
    }
    // Aggregate is display text; resolve to the option id since status fields are id-keyed post-migration.
    const canonicalStatusId = this.nodeTableHelper.getCanonicalStatusIdForNode(this.selectedNodeViewIntance, aggregateStatus);
    this.formData[this.testStatusField.id] = canonicalStatusId;
    if (this.selectedWorkspaceInstanceNode?.fields) {
      this.selectedWorkspaceInstanceNode.fields[this.testStatusField.id] = canonicalStatusId;
    }
    this.cdr.detectChanges();
  }


  // TODO: move labels related logic to the child component

  /**
   * Generic helper to handle target map selection
   */
  private handleTargetMapSelection(selectedArray: IMappedEntityModel[], map: IMappedEntityModel, fieldConstant: string): IMappedEntityModel[] {
    if (!map || !fieldConstant || !this.editPanelTargetMapHelper) {
      return selectedArray;
    }
    const isNewSelection = !this.mapExistsInArray(selectedArray, map.id);
    const updated = this.editPanelTargetMapHelper.addSelection(selectedArray, map);
    this.persistTargetMapSelection(fieldConstant, updated);
    if (isNewSelection && this.isSelectedNodeTestType()) {
      this.shouldForceFromParentFalse = true;
    }
    this.refreshTargetMapSuggestions();
    this.persistAndSaveTargetMaps();
    return updated;
  }

  /**
   * Generic helper to handle target map unselection
   */
  private handleTargetMapUnselection(selectedArray: IMappedEntityModel[], map: IMappedEntityModel, fieldConstant: string): IMappedEntityModel[] {
    if (!map || !fieldConstant || !this.editPanelTargetMapHelper) {
      return selectedArray;
    }
    const updated = this.editPanelTargetMapHelper.removeSelection(selectedArray, map);
    this.persistTargetMapSelection(fieldConstant, updated);
    this.refreshTargetMapSuggestions();
    this.persistAndSaveTargetMaps();
    return updated;
  }

  /**
   * Generic helper to handle target map clear
   */
  private handleTargetMapClear(fieldConstant: string): void {
    if (!fieldConstant) {
      return;
    }
    this.persistTargetMapSelection(fieldConstant, []);
    this.refreshTargetMapSuggestions();
    this.persistAndSaveTargetMaps();
  }

  /**
   * Helper to check if a map exists in an array
   */
  private mapExistsInArray(array: IMappedEntityModel[] | undefined | null, mapId: string | undefined | null): boolean {
    if (!mapId || !array) {
      return false;
    }
    return array.find((m) => m.id === mapId) !== undefined;
  }

  private isSelectedNodeTestType(): boolean {
    const selectedNodeTypeName = this.nodeHelper.getSelectedNodeTypeName(this.selectedWorkspaceInstanceNode);
    return selectedNodeTypeName?.toLowerCase() === BluePrintConstants.TEST_NODE_LOWER;
  }

  public filterTargetMapsLocal(event: AutoCompleteCompleteEvent): void {
    if (!event || !this.editPanelTargetMapHelper) {
      return;
    }
    this.filteredTargetMapsLocal = this.editPanelTargetMapHelper.filterAvailableMaps(event.query, this.allTargetMapsLocal, this.targetMapsLocalSelected);
  }

  public filterTargetMapsUnivl(event: AutoCompleteCompleteEvent): void {
    if (!event || !this.editPanelTargetMapHelper) {
      return;
    }
    this.filteredTargetMapsUnivl = this.editPanelTargetMapHelper.filterAvailableMaps(event.query, this.allTargetMapsUnivl, this.targetMapsUnivlSelected);
  }

  private refreshTargetMapSuggestions(): void {
    if (!this.editPanelTargetMapHelper) {
      return;
    }
    this.filteredTargetMapsLocal = this.editPanelTargetMapHelper.filterAvailableMaps('', this.allTargetMapsLocal, this.targetMapsLocalSelected);
    this.filteredTargetMapsUnivl = this.editPanelTargetMapHelper.filterAvailableMaps('', this.allTargetMapsUnivl, this.targetMapsUnivlSelected);
    this.filteredTargetMapsMerged = this.editPanelTargetMapHelper.filterAvailableMaps('', this.allTargetMapsLocal, this.targetMapsMergedSelected);
  }

  private persistAndSaveTargetMaps(): void {
    this.nodeFieldsChanged = true;
    this.formChanged = true;
    if (this.myForm && !this.myForm.form.dirty) {
      this.myForm.form.markAsDirty();
    }
    this.saveWork();
  }

  public onTargetMapLocalSelect(map: IMappedEntityModel): void {
    if (!map) {
      return;
    }
    this.targetMapsLocalSelected = this.handleTargetMapSelection(this.targetMapsLocalSelected, map, BluePrintConstants.NODETYPE_LOCAL_TARGET_MAPS_FIELD);
  }

  public onTargetMapLocalUnselect(map: IMappedEntityModel): void {
    if (!map) {
      return;
    }
    this.targetMapsLocalSelected = this.handleTargetMapUnselection(this.targetMapsLocalSelected, map, BluePrintConstants.NODETYPE_LOCAL_TARGET_MAPS_FIELD);
  }

  public onTargetMapsLocalClear(): void {
    this.targetMapsLocalSelected = [];
    this.handleTargetMapClear(BluePrintConstants.NODETYPE_LOCAL_TARGET_MAPS_FIELD);
  }

  public onTargetMapUnivlSelect(map: IMappedEntityModel): void {
    if (!map) {
      return;
    }
    this.targetMapsUnivlSelected = this.handleTargetMapSelection(this.targetMapsUnivlSelected, map, BluePrintConstants.NODETYPE_UNIVL_TARGET_MAPS_FIELD);
  }

  public onTargetMapUnivlUnselect(map: IMappedEntityModel): void {
    if (!map) {
      return;
    }
    this.targetMapsUnivlSelected = this.handleTargetMapUnselection(this.targetMapsUnivlSelected, map, BluePrintConstants.NODETYPE_UNIVL_TARGET_MAPS_FIELD);
  }

  public onTargetMapsUnivlClear(): void {
    this.targetMapsUnivlSelected = [];
    this.handleTargetMapClear(BluePrintConstants.NODETYPE_UNIVL_TARGET_MAPS_FIELD);
  }

  public filterTargetMapsMerged(event: AutoCompleteCompleteEvent): void {
    if (!event) {
      return;
    }
    // Filter from all available local maps (assuming local and universal available maps are identical/superset)
    if (this.editPanelTargetMapHelper && this.allTargetMapsLocal && this.targetMapsMergedSelected) {
      this.filteredTargetMapsMerged = this.editPanelTargetMapHelper.filterAvailableMaps(event.query, this.allTargetMapsLocal, this.targetMapsMergedSelected);
    }
  }

  public onTargetMapMergedSelect(map: IMappedEntityModel): void {
    if (!map || !map.id) {
      return;
    }

    // Logic: Add to Merged. Add to Local if Field exists, else Universal.
    // If Map is already in one of them, it shouldn't be selectable ideally, but we handle it.

    // Check if it's already in merged (Unlikely if filtered correctly, but safe keeping)
    if (this.targetMapsMergedSelected && !this.mapExistsInArray(this.targetMapsMergedSelected, map.id)) {
      this.targetMapsMergedSelected.push(map);
    }

    let changed = false;
    const shouldUseLocal = this.isSelectedNodeTestType() && !!this.localNodeField;

    if (shouldUseLocal) {
      if (!this.mapExistsInArray(this.targetMapsLocalSelected, map.id)) {
        this.onTargetMapLocalSelect(map);
        changed = true;
      }
    } else if (this.univeralNodeField) {
      if (!this.mapExistsInArray(this.targetMapsUnivlSelected, map.id)) {
        this.onTargetMapUnivlSelect(map);
        changed = true;
      }
    } else if (this.localNodeField) {
      if (!this.mapExistsInArray(this.targetMapsLocalSelected, map.id)) {
        this.onTargetMapLocalSelect(map);
        changed = true;
      }
    }

    if (!changed) {
      this.refreshTargetMapSuggestions();
    }
  }

  public onTargetMapMergedUnselect(map: IMappedEntityModel): void {
    if (!map || !map.id) {
      return;
    }

    // Remove from merged
    if (this.targetMapsMergedSelected) {
      this.targetMapsMergedSelected = this.targetMapsMergedSelected.filter((m) => m.id !== map.id);
    }

    // Remove from Local if present
    if (this.mapExistsInArray(this.targetMapsLocalSelected, map.id)) {
      this.onTargetMapLocalUnselect(map);
    }

    // Remove from Universal if present
    if (this.mapExistsInArray(this.targetMapsUnivlSelected, map.id)) {
      this.onTargetMapUnivlUnselect(map);
    }
  }

  public onTargetMapsMergedClear(): void {
    this.targetMapsMergedSelected = [];
    if (this.targetMapsLocalSelected?.length > 0) {
      this.onTargetMapsLocalClear();
    }
    if (this.targetMapsUnivlSelected?.length > 0) {
      this.onTargetMapsUnivlClear();
    }
  }

  // TODO END

  public OnTableEditActivate() {
    this.myForm.form.markAsDirty();
  }

  public onStepAttahcmentAdded(stepData: TestStep | ITestStepInstanceModel): void {
    if (!stepData) return;
    const targetStep = this.fieldDataArray[3]?.find((step: any) => step.id === stepData.id);
    if (targetStep) {
      targetStep.attachments = stepData.attachments;
      this.saveWork();
    }
  }

  public onStepFieldInputChange(value: string, fieldName: string): void {
    if (this.isBacklogRollupReadOnly) return;
    const stepId = this.selectedTestStep.id;
    if (stepId) {
      const stepData = this.fieldDataArray[3][stepId - 1];
      stepData[fieldName] = value;
      this.saveWork();
    }
  }

  // An inline image in a test step field uploads as a real attachment but that upload has
  // no notion of "this belongs to test step N" — the step's own attachments array is
  // purely client-side bookkeeping (same convention as onStepAttahcmentAdded / the
  // paperclip attach flow), so record it here and save immediately.
  public onStepFieldImageAttached(attachmentId: string): void {
    if (!attachmentId || this.isBacklogRollupReadOnly) {
      return;
    }
    // selectedTestStep comes from a store emission and can be null; fieldDataArray starts as []
    // so [3] can be undefined, and stepId - 1 can fall outside the row list — guard the whole
    // path, matching how this same access is guarded elsewhere in this file.
    const stepId = this.selectedTestStep?.id;
    if (!stepId) {
      return;
    }
    const stepData = this.fieldDataArray?.[3]?.[stepId - 1];
    // Unconditional save — see the note on TestStepTableComponent.onStepFieldImageAttached.
    // recordStepAttachment returning false just means the picker had already pushed the id
    // onto this step; the step field's HTML still changed and still has to be persisted.
    this.editPanelTestStepHelper.recordStepAttachment(stepData, attachmentId);
    this.saveWork();
  }

  public onAddTestStep(): void {
    if (this.isBacklogRollupReadOnly) return;
    const testTable = this.fieldDataArray && this.fieldDataArray[3];
    const updatedTable = this.editPanelTestStepHelper.addStep(testTable, this.editPanelTestStepHelper.getDefaultStepStatus(this.selectedWorkspace));
    if (!updatedTable) {
      return;
    }
    this.fieldDataArray[3] = updatedTable;
    // Update the count immediately for the UI
    this.numberOfTestSteps = updatedTable?.length ?? 0;
    this.isAddingTestStep = true;
    this.updateTestStatusFromSteps(updatedTable);
    // Trigger change detection to update the UI immediately
    this.cdr.markForCheck();
    this.saveWork();
  }

  public onGetTableDataOutput(event: any): void {
    if (!event || !event.data || !Array.isArray(event.data)) {
      return;
    }

    // The cell-edit completion for the node we just left arrives here after navigation has already
    // swapped selectedWorkspaceInstanceNode. Its payload is the previous node's steps, so applying
    // it would leave formData/fieldTableDataArray describing the old node while addressed to the
    // new one — which the next save would then flush to the wrong node. Nothing is lost by ignoring
    // it: onNavigationClicked already committed and saved these same edits against the node they
    // belong to before navigating (ZOO-10027).
    if (this.fieldDataNodeId && this.fieldDataNodeId !== this.selectedWorkspaceInstanceNode?.id) {
      return;
    }

    const tableData = event.data;
    const index = Number.isInteger(event.index) ? Number(event.index) : this.testTableFieldIndex ?? 3;

    this.fieldDataArray[index] = tableData;
    if (this.tableField?.id) {
      this.fieldTableDataArray[this.tableField.id] = this.helperService.getDeepCopy(tableData);
    }
    this.numberOfTestSteps = tableData.length;

    // Keep formData in sync so getFormFieldsData() reads current table data
    if (this.tableField?.id) {
      this.formData[this.tableField.id] = JSON.stringify(tableData);
    }
    this.updateTestStatusFromSteps(tableData);

    this.formChanged = true;
    if (this.myForm && !this.myForm.form.dirty) {
      this.myForm.form.markAsDirty();
    }
    this.cdr.markForCheck();
    // Persist immediately, matching every other field handler in this file
    // (onDropDownChange, onInputBlur, onAddTestStep). Without this, step
    // edits and the cascaded test-status update sit in formData until the
    // panel is closed or clicked outside, leaving downstream views (Runs
    // tab, board, etc.) stale.
    //
    // updateResponse=false: this save fires as the user Tabs/clicks into the next cell. Letting the
    // response re-select the node (setInFocus/itemInFocus, then the $selectedWSINode reload into
    // loadInitialData/constructFields) pulled focus to the main view and rebuilt the step table
    // under the cell just opened, leaving it uneditable with Tab dead. The panel already holds
    // everything this save sent; downstream views still refresh through updateView.
    this.saveWork(false);
  }

  // public onCreateChildNodeClicked(event?: Event): void {
  //   if ((this.myForm.form.dirty && this.myForm.form.touched) || this.formChanged) {
  //     this.saveWork(true, false);
  //   }
  //   if (event && this.headerComponent) {
  //     this.headerComponent.toggleChildMenu(event);
  //   }
  // }

  onDropDownChange(value: any, field: string | undefined) {
    if (field) {
      // Try finding by ID first, then by Name
      const fieldObj = this.fieldList.find((f) => f.id === field || f.name === field);
      if (fieldObj) {
        this.formData[fieldObj.id] = value;
      }
    }

    if (field && field.toLocaleLowerCase() === BluePrintConstants.TEST_STATUS_FIELD_LOWER) {
      this.statusChangeHandler(value);
      return;
    }
    this.formChanged = true;
    if (this.myForm && !this.myForm.form.dirty) {
      this.myForm.form.markAsDirty();
    }
    this.saveWork();
  }

  public onInputBlur(value: any, field: string | undefined) {
    let didChange = true;
    let persistedValue: any = undefined;

    if (field) {
      // Try finding by ID first, then by Name
      const fieldObj = this.fieldList.find((f) => f.id === field || f.name === field);
      if (fieldObj) {
        persistedValue = this.selectedWorkspaceInstanceNode?.fields?.[fieldObj.id];
        didChange = this.hasMeaningfulValueChange(persistedValue, value);
        if (didChange) {
          this.formData[fieldObj.id] = value;
        }
      } else {
        const bugFieldObj = this.bugFieldList.find((f) => f.id === field || f.name === field);
        if (bugFieldObj) {
          persistedValue = this.selectedWorkspaceInstanceNode?.fields?.[bugFieldObj.id];
          didChange = this.hasMeaningfulValueChange(persistedValue, value);
          if (didChange) {
            this.formData[bugFieldObj.id] = value;
          }
        }
      }
    }

    if (!didChange) {
      return;
    }

    this.formChanged = true;
    if (this.myForm && !this.myForm.form.dirty) {
      this.myForm.form.markAsDirty();
    }
    this.saveWork();
  }

  private hasMeaningfulValueChange(previous: any, current: any): boolean {
    if (previous === current) {
      return false;
    }

    if ((previous === null || previous === undefined) && (current === null || current === undefined)) {
      return false;
    }

    if (previous instanceof Date || current instanceof Date) {
      const previousDate = previous instanceof Date ? previous.getTime() : new Date(previous).getTime();
      const currentDate = current instanceof Date ? current.getTime() : new Date(current).getTime();

      if (isNaN(previousDate) && isNaN(currentDate)) {
        return false;
      }

      if (isNaN(previousDate) || isNaN(currentDate)) {
        return true;
      }

      return previousDate !== currentDate;
    }

    if (typeof previous === 'object' && typeof current === 'object' && previous && current) {
      try {
        return JSON.stringify(previous) !== JSON.stringify(current);
      } catch {
        return true;
      }
    }

    return String(previous) !== String(current);
  }

  private statusChangeHandler(testStatus: string): void {
    if (!testStatus || !this.selectedWorkspaceInstanceNode) {
      return;
    }
    //console.log(testStatus);
    const testTableField = this.editPanelTestStepHelper.getTestTableField(this.selectedWorkspace);
    if (testTableField) {
      const fieldKeys = Object.keys(this.selectedWorkspaceInstanceNode?.fields ?? {});
      const testTableIndex = fieldKeys.indexOf(testTableField.id);
      if (testTableIndex !== -1) {
        // testing table found in the node
        const tableOutput = this.fieldDataArray[testTableIndex];
        if (tableOutput && tableOutput?.length > 0) {
          const config = this.editPanelTestStepHelper.buildTestStatusConfig(this.selectedWorkspace);
          const updatedSteps = this.editPanelTestStepHelper.syncStepsWithTestStatus(tableOutput, testStatus, config);
          this.fieldDataArray[testTableIndex] = updatedSteps;
          if (testStatus?.toLowerCase().trim() !== config?.inProgressLower) {
            this.updateTestStatusFromSteps(updatedSteps);
          }
        }
      }
    }
  }

  // construct fields
  private constructFields() {
    if (!this.selectedWorkspace || !this.selectedBlueprint?.nodes || !this.selectedBlueprint?.fields) {
      return;
    }
    const blueprint = this.selectedBlueprint;

    this.fieldDataArray = [];
    this.fieldList = [];
    this.fieldTableDataArray = {};
    this.tableConfigurationArray = [];
    this.targetMapsUnivlSelected = [];
    this.targetMapsLocalSelected = [];
    this.testTableFieldIndex = null;

    this.epicNameField =
      blueprint.fields.find((bf) => bf.name.toLocaleLowerCase() === BluePrintConstants.EPIC_NAME_FIELD_LOWER && bf.fieldType.toLocaleLowerCase() === BluePrintConstants.INPUT_TYPE_TEXT) || null;
    const targetMapUnivlField = blueprint.fields.find((f) => f.name.toLocaleLowerCase().trim() === BluePrintConstants.NODETYPE_UNIVL_TARGET_MAPS_FIELD) || null;

    const targetMapLocalField = blueprint.fields.find((f) => f.name.toLocaleLowerCase().trim() === BluePrintConstants.NODETYPE_LOCAL_TARGET_MAPS_FIELD) || null;

    if (this.selectedWorkspaceInstanceNode) {
      // Epic Name used to be defaulted into selectedWorkspaceInstanceNode.fields right here, which
      // meant every save of an Epic with a still-empty Epic Name - even one that only touched
      // Description - silently persisted a "Description -> Epic Name" value nobody typed, and
      // logged it to Audit History as a real edit. The default is now applied to formData only
      // (applyEpicNameDisplayDefault, called after this rebuilds it) so it is still shown as
      // editable text, and getFieldsDataEnocded strips it back out at save time unless the user
      // actually changed it - see isUnconfirmedEpicNameDefault.

      const nodetypeId = this.selectedWorkspaceInstanceNode['nodeTypeId'];
      let fieldsInNode = [];

      // construct node field list
      for (const node in blueprint.nodes) {
        if (blueprint.nodes[node].id === nodetypeId) {
          fieldsInNode = blueprint.nodes[node].fields;
          break;
        }
      }

      for (const key in fieldsInNode) {
        const blueprintField = blueprint.fields.find((e) => e.id === key);
        if (blueprintField) {
          const blueprintFieldCopy = this.helperService.getDeepCopy(blueprintField);
          this.fieldList.push(blueprintFieldCopy);
        }
      }
      this.isTestNode = this.hasTable(this.fieldList);
      // isTestNode decides whether Steps/Runs exist for this node, so the kept tab is re-validated here.
      this.ensureActiveTabVisibility();
      this.constructFieldIdTypeDictionary();
      this.constructBugFieldList();
      this.constructDetailFieldList();
      this.constructApplyNodeFields();
      this.nodeStatusFieldId = this.nodeHelper.getNodeStatusFieldId(this.selectedWorkspaceInstanceNode);
      this.isShowNodeStatus = !!this.nodeStatusFieldId;
      //('fieldList', this.fieldList);

      let fieldIndex = 0;

      if (this.selectedWorkspaceInstanceNode.fields) {
        for (const key in this.selectedWorkspaceInstanceNode.fields) {
          const fieldTypeLower = (this.fieldIdTypeDictionary[key] ?? '').toLowerCase();
          if (fieldTypeLower === 'table') {
            this.constructTableField(key, fieldIndex);
          } else if (fieldTypeLower === 'user') {
            this.constructUserField(key);
            this.fieldDataArray.push(this.selectedWorkspaceInstanceNode.fields[key]);
          } else if (fieldTypeLower === 'formattedtext') {
            this.fieldDataArray.push(this.selectedWorkspaceInstanceNode.fields[key]);
          } else if (fieldTypeLower === 'checkbox') {
            this.constructCheckboxField(key);
          } else if (fieldTypeLower === 'dropdownmultiple') {
            if (this.selectedWorkspaceInstanceNode.fields[key]) {
              this.fieldDataArray.push(this.selectedWorkspaceInstanceNode.fields[key]?.split('\n'));
            }
          } else {
            const fieldType = this.fieldList.find((f) => f.id === key);
            if (fieldType) {
              // In case of external app reference id, it is read-only, and hide it if it empty
              if (fieldType.value.isReadOnly && this.selectedWorkspaceInstanceNode.fields[key] === '') {
                // ieldType.isVisible = false;
              }
              // else {
              //   fieldType.isVisible = true;
              // }
            }
            this.fieldDataArray.push(this.selectedWorkspaceInstanceNode.fields[key]);

            if (targetMapUnivlField) {
              // prepopulate saved target maps for chips control
              if (key === targetMapUnivlField.id) {
                const savedTargetMaps = this.selectedWorkspaceInstanceNode.fields[key]?.split(',');
                if (savedTargetMaps?.length > 0) {
                  savedTargetMaps.forEach((savedTargetMap: any) => {
                    // Resolve against allTargetMapsAny (not the archived-filtered allTargetMapsUnivl) so a
                    // previously-saved reference still shows a chip even if that map was later archived.
                    const targetMap = this.allTargetMapsAny.find((tm) => tm.id === savedTargetMap);
                    if (targetMap) {
                      this.targetMapsUnivlSelected.push(targetMap); // chips control read from this variable
                    }
                  });
                }
              }
            }

            if (targetMapLocalField) {
              // prepopulate saved target maps for chips control
              if (key === targetMapLocalField.id) {
                const savedTargetMaps = this.selectedWorkspaceInstanceNode.fields[key]?.split(',');
                if (savedTargetMaps?.length > 0) {
                  savedTargetMaps.forEach((savedTargetMap: any) => {
                    // Resolve against allTargetMapsAny (not the archived-filtered allTargetMapsLocal) so a
                    // previously-saved reference still shows a chip even if that map was later archived.
                    const targetMap = this.allTargetMapsAny.find((tm) => tm.id === savedTargetMap);
                    if (targetMap) {
                      this.targetMapsLocalSelected.push(targetMap); // chips control read from this variable
                    }
                  });
                }

                if (this.targetMapsLocalSelected.length === 0) {
                  const backlogMap = this.allTargetMapsLocal.find((tm) => tm.name.toLowerCase() === 'backlog');
                  if (backlogMap) {
                    this.targetMapsLocalSelected.push(backlogMap);
                  }
                  // Also pre-fill the current workspace/label if it's not backlog
                  const currentMap = this.allTargetMapsLocal.find((tm) => tm.id === this.selectedWorkspace?.id);
                  if (currentMap && currentMap.name.toLowerCase() !== 'backlog') {
                    this.targetMapsLocalSelected.push(currentMap);
                  }
                }
              }
            }
          }
          ++fieldIndex;
        }
      }
    }
    //console.log('fielddataarray');
    //console.log(this.fieldDataArray);

    // Combine local and universal into merged
    const combined = [...this.targetMapsUnivlSelected, ...this.targetMapsLocalSelected];
    this.targetMapsMergedSelected = _.uniqBy(combined, 'id');

    this.refreshTargetMapSuggestions();

    // Record which node these freshly-built field arrays belong to — see onGetTableDataOutput.
    this.fieldDataNodeId = this.selectedWorkspaceInstanceNode?.id ?? null;
    // Baseline the step table as loaded, so a later edit to it is detectable.
    const loadedSteps = this.getTableData(this.fieldDataArray);
    this.committedStepsJson = Array.isArray(loadedSteps) ? JSON.stringify(loadedSteps) : null;
  }

  public checkAndSaveAssigneeValid(event: { index: number; userId: string; fieldId: string; fieldName: string }) {
    const { index, userId, fieldId } = event;
    const user = this.userList.find((u) => u.id === userId);
    if (user && !user.isActive) {
      this.alertService.alert(NotificationType.Error, 'Cannot assign to an Inactive user', true);
      return;
    }

    if (fieldId && this.selectedWorkspaceInstanceNode?.fields && fieldId in this.selectedWorkspaceInstanceNode.fields) {
      // Find the correct index in fieldDataArray.
      // In constructFields, fieldDataArray is populated based on the iteration order of selectedWorkspaceInstanceNode.fields
      const fieldKeys = Object.keys(this.selectedWorkspaceInstanceNode.fields);
      const dataIndex = fieldKeys.indexOf(fieldId);
      if (dataIndex !== -1) {
        this.fieldDataArray[dataIndex] = userId;
      }

      this.selectedWorkspaceInstanceNode.fields[fieldId] = userId;
      this.formData[fieldId] = userId;
    }

    this.cdr.detectChanges();
    this.formChanged = true;
    if (this.myForm && !this.myForm.form.dirty) {
      this.myForm.form.markAsDirty();
    }
    this.saveWork();
  }

  private constructCheckboxField(key: string) {
    if (this.selectedWorkspaceInstanceNode && (this.selectedWorkspaceInstanceNode.fields[key] === 'true' || this.selectedWorkspaceInstanceNode.fields[key] === true)) {
      this.fieldDataArray.push(true);
    } else {
      this.fieldDataArray.push(false);
    }
  }

  private constructTableField(key: string, fieldIndex: number) {
    const tableField = this.fieldList.find((field) => field.id === key);
    if (tableField) {
      this.tableField = tableField;
      this.testTableFieldIndex = fieldIndex;
      if (tableField.value.value) {
        tableField.value.value.forEach((element: any) => {
          if (element['options']) {
            const options: string = element['options'];
            if (!Array.isArray(options)) {
              element['options'] = options?.split('\n');
            } else {
              element['options'] = options;
            }
          }
        });
      }
      this.tableConfigurationArray[fieldIndex] = tableField.value.value;

      const tabledata = this.selectedWorkspaceInstanceNode?.fields[key];
      // .replace(new RegExp('&#39;', 'g'), "'");//.replace(new RegExp('&#34;', 'g'), '\\\"');

      // console.log(this.selectedWorkspaceInstanceNode.fields[key]);
      // const tabledata = this.selectedWorkspaceInstanceNode.fields[key].replace(/&#34;/g, "\\'").replace(/&#32;/g, "\'").replace(/'/g, '"').replace(/&#39;/g, "'");
      //console.log(tabledata);
      let tabledataJsonFormat = null;
      if (tabledata) {
        try {
          tabledataJsonFormat = JSON.parse(tabledata);
        } catch (e) {
          console.error('Error parsing table data', e);
        }
      }
      if (tabledataJsonFormat) {
        this.numberOfTestSteps = tabledataJsonFormat?.length;
      }

      tabledataJsonFormat = this.normalizeTableRowMarkup(this.helperService.sanitizeJson(tabledataJsonFormat));
      //console.log(tabledataJsonFormat);
      this.fieldTableDataArray[key] = tabledataJsonFormat;
      this.formData[key] = tabledataJsonFormat;
      this.fieldDataArray.push(tabledataJsonFormat);
    } else {
      this.tableConfigurationArray[fieldIndex] = [];
      this.fieldDataArray.push([]);
      this.formData[key] = [];
    }
  }

  private constructFieldIdTypeDictionary() {
    this.fieldList.forEach((field) => {
      if (field) {
        const type = (field.fieldType || '').toLowerCase();
        const normalizedType = type.startsWith('blueprintfield') ? type.replace('blueprintfield', '') : type;
        this.fieldIdTypeDictionary[field.id] = normalizedType;
      }
    });
  }

  // A blank item type means "no parent item" to the rule, which is the header chat's case rather
  // than the panel's, so an item without one offers nothing here.
  private updateGenerateTestsAvailability(): void {
    const nodeTypeId = this.selectedWorkspaceInstanceNode?.nodeTypeId;
    if (!nodeTypeId) {
      this.generateTestsState = IntelliCatchAvailabilityState.NotApplicable;
      this.generateTestsBlockedReason = '';
      return;
    }

    const availability = this.intelliCatchAvailabilityHelper?.getGenerateTestsAvailability(nodeTypeId);
    this.generateTestsState = availability?.state ?? IntelliCatchAvailabilityState.NotApplicable;
    this.generateTestsBlockedReason = availability?.reason ?? '';
  }

  private getChildNodeNameList(): void {
    if (!this.selectedWorkspaceInstanceNode?.nodeTypeId) return;
    const names = this.blueprintDataHelper.parentChildNodesNameMap?.get(this.selectedWorkspaceInstanceNode.nodeTypeId) || [];
    const fullBlueprint = this.blueprintStore.selectedBluePrint || this.selectedBlueprint;
    this.childNodeNameList = names.map((name) => {
      const nodeId = this.blueprintDataHelper.nodeNameIdMap?.get(name.toLowerCase());
      const blueprintNode = nodeId ? fullBlueprint?.nodes?.find((n) => n.id === nodeId) : undefined;
      const displayName = blueprintNode?.label?.trim() || blueprintNode?.name || _.capitalize(name);
      return {
        name,
        displayName,
        backgroundColor: blueprintNode?.backgroundColor,
        textColor: blueprintNode?.textColor,
        borderColor: blueprintNode?.borderColor,
        borderThickness: blueprintNode?.borderThickness,
      };
    });
  }

  private getFormFieldsData(): { [fieldId: string]: any } {
    const currentFieldDataList: { [fieldId: string]: any } = {};
    const nodeStatusFieldId = this.nodeHelper.getNodeStatusFieldId(this.selectedWorkspaceInstanceNode);

    this.fieldList.forEach((field) => {
      // A field without an id can never be a real field ref - keying the payload with it would
      // serialize to a literal "undefined"/"" property that the backend would otherwise persist.
      if (!field?.id) return;
      const fieldId = field.id;

      if (this.isUnconfirmedEpicNameDefault(fieldId)) {
        currentFieldDataList[fieldId] = this.selectedWorkspaceInstanceNodeOldVal?.fields?.[fieldId] ?? '';
        return;
      }

      let rawValue = this.formData[fieldId];
      if (fieldId === nodeStatusFieldId && typeof rawValue === 'string') {
        rawValue = this.nodeTableHelper.getCanonicalStatusIdForNode(this.selectedNodeViewIntance, rawValue);
      }

      const fieldType = (field.fieldType || '').toLowerCase();
      const normalizedType = fieldType.startsWith('blueprintfield') ? fieldType.replace('blueprintfield', '') : fieldType;

      switch (normalizedType) {
        case 'dropdownmultiple': {
          if (Array.isArray(rawValue)) {
            rawValue = rawValue.join('\n');
          }
          currentFieldDataList[fieldId] = rawValue;
          break;
        }

        case 'table': {
          let tabledataJsonFormat = null;
          if (rawValue) {
            if (typeof rawValue === 'string') {
              try {
                tabledataJsonFormat = JSON.parse(rawValue);
              } catch (e) {
                console.error('Error parsing table data JSON string:', e);
              }
            } else if (typeof rawValue === 'object') {
              tabledataJsonFormat = rawValue;
            }
          }

          if (tabledataJsonFormat) {
            this.numberOfTestSteps = tabledataJsonFormat?.length;
          }

          tabledataJsonFormat = this.normalizeTableRowMarkup(this.helperService.sanitizeJson(tabledataJsonFormat));

          currentFieldDataList[fieldId] = JSON.stringify(this.removeCatchIndexAndAddPositionToTableData(tabledataJsonFormat ?? []));
          break;
        }
        case 'date':
        case 'datetime': {
          if (rawValue instanceof Date) {
            currentFieldDataList[fieldId] = rawValue.toISOString();
          } else {
            currentFieldDataList[fieldId] = rawValue;
          }
          break;
        }

        default: {
          // For text, memo, single dropdown, etc.
          if (typeof rawValue === 'string') {
            currentFieldDataList[fieldId] = rawValue.trim();
          } else {
            currentFieldDataList[fieldId] = rawValue;
          }
          break;
        }
      }
    });
    return currentFieldDataList;
  }

  private getFieldsDataEnocded() {
    const currentFieldDataList: any = {};
    if (this.fieldList) {
      this.fieldList.forEach((field) => {
        // A field without an id can never be a real field ref - keying the payload with it would
        // serialize to a literal "undefined"/"" property that the backend would otherwise persist.
        if (field?.id) {
          if (this.isUnconfirmedEpicNameDefault(field.id)) {
            currentFieldDataList[field.id] = this.selectedWorkspaceInstanceNodeOldVal?.fields?.[field.id] ?? '';
            return;
          }

          const type = (field.fieldType || '').toLowerCase();
          const normalizedType = type.startsWith('blueprintfield') ? type.replace('blueprintfield', '') : type;

          if (normalizedType === 'table') {
            const originalTableData = this.fieldTableDataArray[field.id];
            if (originalTableData && Array.isArray(originalTableData)) {
              const tableValue = this.helperService.getDeepCopy(originalTableData);
              tableValue.forEach((fieldval: any) => {
                for (const stepKey of Object.keys(fieldval)) {
                  let stepKeyValue = fieldval[stepKey];
                  if (typeof stepKeyValue === 'string' && stepKeyValue) {
                    stepKeyValue = this.helperService.esc(stepKeyValue); // escape the special characters
                    fieldval[stepKey] = stepKeyValue;
                  }
                }
              });

              const val = JSON.stringify(this.removeCatchIndexAndAddPositionToTableData(tableValue));
              if (val) currentFieldDataList[field.id] = val;
            }
          } else if (normalizedType === 'dropdownmultiple') {
            if (this.formData[field.id]) {
              currentFieldDataList[field.id] = this.convertToStringwithNewlineCharacter(this.formData[field.id]);
            }
          } else {
            if (this.formData[field.id] && typeof this.formData[field.id] === 'string') {
              currentFieldDataList[field.id] = this.formData[field.id].trim();
            } else {
              currentFieldDataList[field.id] = this.formData[field.id];
            }
          }
        } else {
          //this.helperService.sendAdminLogs('The field reference is available, but field not available in blueprint '
          //+ this.selectedBlueprint.id + ' ( ' + this.selectedBlueprint.name + ' )', LogType.Error);
        }
      });
      return currentFieldDataList;
    }
  }

  private convertToStringwithNewlineCharacter(selection: any) {
    let finalString = '';
    if (Array.isArray(selection)) {
      selection.forEach((element) => {
        finalString += element + '\n';
      });
      finalString = finalString.slice(0, -1);
    }
    return finalString;
  }

  public saveWork(updateResponse: boolean = true, updatedJira = false, callback?: () => void, updateView = true) {
    if (!this.selectedWorkspaceInstanceNode) {
      return;
    }
    // Hard stop. The payload is built from fieldTableDataArray/formData/fieldList but is addressed
    // to selectedWorkspaceInstanceNode. Navigation swaps that node synchronously while
    // constructFields() rebuilds those structures in a later setTimeout, so in that window any save
    // — a deferred PrimeNG onEditComplete, an attachment upload that resolves late, any async
    // handler — would write the previous node's steps/fields onto the newly selected one. No
    // legitimate save exists in that window: saveWork can only ever target the current selection,
    // so a mismatch always means the data is stale. Refuse rather than corrupt (ZOO-10027).
    // Pending work is not lost — onNavigationClicked commits and saves it against the correct node
    // before it navigates.
    if (this.fieldDataNodeId && this.fieldDataNodeId !== this.selectedWorkspaceInstanceNode.id) {
      console.warn('[edit-panel] Skipped save: field data belongs to node', this.fieldDataNodeId, 'but', this.selectedWorkspaceInstanceNode.id, 'is selected.');
      return;
    }
    this.eventManager.hasUnsavedChanges = true;
    // Whatever the step table currently shows is what gets serialised - see syncStepTableIntoPayload
    // for why this cannot be left to the individual mutation paths to keep in step.
    this.syncStepTableIntoPayload(this.getTableData(this.fieldDataArray));
    const nodeToBeSaved = this.nodeFactory.createNodeInstanceFromObject(this.helperService.getDeepCopy(this.selectedWorkspaceInstanceNode));
    const encodedFields = this.getFieldsDataEnocded(); // only encoded string is required for backend not for UI
    // const fieldsData = this.getFieldsData(); //
    const fieldsFormData = this.getFormFieldsData();
    this.selectedWorkspaceInstanceNode.fields = fieldsFormData;
    if (nodeToBeSaved) nodeToBeSaved.fields = encodedFields;

    if (nodeToBeSaved) {
      this.workspaceService.setModifyPropertyBinding({
        nodeId: nodeToBeSaved.id,
        blueprintNodeId: nodeToBeSaved.nodeTypeId,
        fields: fieldsFormData,
      });

      this.workspaceService.setModifyNodeToolTip({
        nodeId: nodeToBeSaved.id,
        description: nodeToBeSaved.description,
      });

      if (!this.fieldHelper.getFieldValue(this.selectedWorkspaceInstanceNode, this.dueDateFieldId)) {
        this.fieldHelper.setFieldValue(this.selectedWorkspaceInstanceNode, this.dueDateFieldId, null);
      }

      const patchPayload: PatchNodeInstancePayload = new PatchNodeInstancePayload();
      patchPayload.workspaceId = this.selectedWorkspace?.id || '';
      patchPayload.nodeInstanceItem = nodeToBeSaved;
      patchPayload.updateResponse = updateResponse;
      this.oldName = nodeToBeSaved.name; // the latest name is saved as old name now
      // Use selectedWorkspaceInstanceNode (which has UI-friendly fieldsFormData) rather than
      // nodeToBeSaved (which has backend-encoded fields). If we stored nodeToBeSaved here, the
      // panel-close restore at line ~848 would write encoded fields back into the workspace, and
      // on next open buildFormData cannot read the status (or any field) correctly, causing an
      // apparent reset to default.
      this.selectedWorkspaceInstanceNodeOldVal = this.helperService.getDeepCopy(this.selectedWorkspaceInstanceNode);
      // this.uiStateStore.startBackendAction('Saving Node...');
      this.myForm.form.markAsPristine();
      this.formChanged = false;
      const tempId = nodeToBeSaved.id;
      const tempName = nodeToBeSaved.name;
      const forceFromParentFalse = this.shouldForceFromParentFalse;
      this.shouldForceFromParentFalse = false;
      patchPayload.metaData = {};
      patchPayload.metaData.originApp = AppConstants.CATCH_INTERNAL_APP_SMARTMAP_LOWER;
      if (forceFromParentFalse) {
        patchPayload.metaData[AppConstants.METADATA_FORCE_FROM_PARENT_FALSE] = true;
      }
      if (!updatedJira && this.jiraHelper.isJiraProject()) {
        // New Jira bug node created check, so duplicate saving of Jira is avoided
        // if jira bug node, then update back to Jira
        patchPayload.metaData.projectType = 'jira';
        // patchPayload.metaData.issuePayLoad = this.getUpdateJiraIssuePayLoad();
      }

      if (this.classicETHelper.isClassicETProject()) {
        // New Jira bug node created check, so duplicate saving of Jira is avoided
        // if jira bug node, then update back to Jira
        patchPayload.metaData.projectType = 'classic';
        // patchPayload.metaData.issuePayLoad = this.getUpdateJiraIssuePayLoad();
      }

      if (this.subscribers.patchWSINode) {
        this.subscribers.patchWSINode.unsubscribe();
      }

      // Cancelling the in-flight save above also throws away whatever was queued to run once it
      // came back. That is how navigation was getting lost: onNavigationClicked starts a save
      // carrying navigateFun, then PrimeNG's deferred cell-edit completion lands and issues its own
      // callback-less saveWork(), which unsubscribes the first — the node saved, but the user never
      // moved. Carry the queued work over to the save that replaced it (ZOO-10027).
      this.pendingSaveCallback = callback ?? this.pendingSaveCallback;

      //TODO - Move these code to Node Helper ( duplicate logic in many places)
      this.subscribers.patchWSINode = this.workspaceStore.$patchWSINode(patchPayload, false, updateView).subscribe((result) => {
        this.cdr.detectChanges();
        this.dashboardHelper.setModifiedPropertyItem({
          id: tempId,
          name: tempName,
        });
        if (this.pendingSaveCallback) {
          // Read pendingSaveCallback live rather than a callback captured when this save started:
          // onClickCloseRightPanel can queue a close callback onto it after this save is already
          // in flight (e.g. right after a summary-blur save), and that must still run here. Cleared
          // before invoking: navigating re-enters this component, and a later unrelated save must
          // not inherit a callback that has already run.
          const pendingCallback = this.pendingSaveCallback;
          this.pendingSaveCallback = undefined;
          pendingCallback();
        }
        this.eventManager.hasUnsavedChanges = false;
        this.formChanged = false;
        //This block of code is to update the node in the workspace node list when updating the node references field.
        if (this.nodeFieldsChanged && this.selectedWorkspace) {
          this.workspaceStore.$getWorkspaceById(this.selectedWorkspace.id).subscribe((result) => {
            if (result) {
              //this.workspaceStore.constructAndModifyCurrentViewModelList(result);
              this.nodeFieldsChanged = false;
              if (
                this.workspaceStore.nodeInstanceViewModelList &&
                this.workspaceStore.selectedWorkspaceInstance?.nodeInstances &&
                this.workspaceStore.nodeInstanceViewModelList?.length > 0 &&
                this.workspaceStore.selectedWorkspaceInstance?.nodeInstances?.length > 0
              ) {
                // following code looks funny but don't remove it, it is required to update the selected node in the workspace store
                this.workspaceStore.selectedWSINode = this.workspaceStore.selectedWSINode;
              } else {
                this.workspaceStore.selectedWSINode = null;
                this.dashboardHelper.setShowRightPanel(false);
              }
            }
          });
        }
      });
    }
  }

  private getUpdateJiraIssuePayLoad() {
    this.selectedProject = this.projectStore.selectedProject;
    //console.log(this.selectedProject);
    if (this.selectedProject && this.selectedProject.integratedApps && this.selectedProject.integratedApps?.length > 0) {
      const jiraProject = this.selectedProject.integratedApps.find((ia) => ia.type.toLocaleLowerCase() === 'jira');
      if (jiraProject) {
        if (this.selectedWorkspaceInstanceNode && this.extRefField && this.selectedWorkspaceInstanceNode.fields[this.extRefField.id] !== '') {
          const updateBugPayload: any = {
            issueKey: this.selectedWorkspaceInstanceNode.fields[this.extRefField.id],
          };
          if (this.selectedWorkspaceInstanceNode.nodeTypeId && this.epicNodeType && this.bugNodeType && this.storyNodeType && this.taskNodeType && this.subTaskNodeType) {
            switch (this.selectedWorkspaceInstanceNode.nodeTypeId) {
              case this.epicNodeType.id: {
                if (this.epicNameField) {
                  updateBugPayload['data'] = {
                    epicName: this.selectedWorkspaceInstanceNode.fields[this.epicNameField?.id]
                      ? this.selectedWorkspaceInstanceNode.fields[this.epicNameField.id]
                      : this.selectedWorkspaceInstanceNode.name,
                    name: this.selectedWorkspaceInstanceNode.name,
                    description: this.selectedWorkspaceInstanceNode.description,
                    type: 'Epic',
                    nodeId: this.selectedWorkspaceInstanceNode.id,
                  };
                }
                // this.workspaceStore.pushBugNode(updateBugPayload, this.selectedWorkspaceInstanceNode.id);
                break;
              }
              case this.bugNodeType.id: {
                updateBugPayload['data'] = {
                  name: this.selectedWorkspaceInstanceNode.name,
                  description: this.selectedWorkspaceInstanceNode.description,
                  type: 'Bug',
                  nodeId: this.selectedWorkspaceInstanceNode.id,
                };
                // this.workspaceStore.pushBugNode(updateBugPayload, this.selectedWorkspaceInstanceNode.id);
                break;
              }
              case this.storyNodeType.id: {
                updateBugPayload['data'] = {
                  name: this.selectedWorkspaceInstanceNode.name,
                  description: this.selectedWorkspaceInstanceNode.description,
                  type: 'Story',
                  nodeId: this.selectedWorkspaceInstanceNode.id,
                };
                // this.workspaceStore.pushBugNode(updateBugPayload, this.selectedWorkspaceInstanceNode.id);
                break;
              }
              case this.taskNodeType.id: {
                updateBugPayload['data'] = {
                  name: this.selectedWorkspaceInstanceNode.name,
                  description: this.selectedWorkspaceInstanceNode.description,
                  type: 'Task',
                  nodeId: this.selectedWorkspaceInstanceNode.id,
                };
                // this.workspaceStore.pushBugNode(updateBugPayload, this.selectedWorkspaceInstanceNode.id);
                break;
              }
              case this.subTaskNodeType.id: {
                updateBugPayload['data'] = {
                  name: this.selectedWorkspaceInstanceNode.name,
                  description: this.selectedWorkspaceInstanceNode.description,
                  type: 'Sub-task',
                  nodeId: this.selectedWorkspaceInstanceNode.id,
                };
                // this.workspaceStore.pushBugNode(updateBugPayload, this.selectedWorkspaceInstanceNode.id);
                break;
              }
            }
            return updateBugPayload;
          }
        }
      }
    }
    return null;
  }

  onChange(val: string) {
    if (val === '') {
      return;
    }
    this.dashboardHelper.setModifiedPropertyItem({
      id: this.selectedWorkspaceInstanceNode?.id,
      name: this.selectedWorkspaceInstanceNode?.name,
    });
  }

  public onAddChildNode(nodeTypeName: string): void {
    this.nodeHelper.createNodeByNodeTypeName(nodeTypeName, DefaultValueConstants.NODE_DEFAULT_NAME, DefaultValueConstants.NODE_SERVER_LOCATION, true);
    this.eventManager.setEditPanelSummaryInHighlight();
  }

  onNameBlur() {
    if (this.selectedWorkspaceInstanceNode && this.selectedWorkspaceInstanceNode.name === '') {
      this.selectedWorkspaceInstanceNode.name = this.oldName; // revert to old name
      this.dashboardHelper.setModifiedPropertyItem({
        // update the diagram
        id: this.selectedWorkspaceInstanceNode.id,
        name: this.selectedWorkspaceInstanceNode.name,
      });
    } else {
      this.oldName = this.selectedWorkspaceInstanceNode?.name || '';
    }
  }

  // A list row whose content is wrapped in a block (<li><p>text</p></li>) renders with its
  // bullet or number stranded on a line above the text. The editor never writes that shape -
  // Quill flattens it, pastes included - but rows created outside the editor can, and the edit
  // panel writes back every field it loaded, not just the edited ones. Repairing the rows here
  // is what gets the stored value cleaned up on the next save of that step.
  // Delegates to the shared helper so this and NodeFactory's load path cannot drift - they
  // repair the same rows for the same reason, and the non-array guard has to hold in both.
  private normalizeTableRowMarkup(rows: any): any {
    return flattenListRowBlocksInRows(rows);
  }

  private removeCatchIndexAndAddPositionToTableData(tableOutput: any[]): any[] {
    const tableDataWithPosition: any = [];
    tableOutput.forEach((row) => {
      const copy = this.helperService.getDeepCopy(row);
      delete copy['catchindex'];
      tableDataWithPosition.push(copy);
    });
    return tableDataWithPosition;
  }

  public onCalendarDateChange(index: number, event: Date | string | null, fieldId: string): void {
    const selectedDate = this.editPanelDateHelper.handleCalendarDateChange({
      rawValue: event,
      fieldId,
      dueDateFieldId: this.dueDateFieldId,
      startDateFieldId: this.startDateFieldId,
      selectedNode: this.selectedWorkspaceInstanceNode,
      formData: this.formData,
      validationMessage: NotificationConstants.DUEDATE_STARTDATE_VALIDATION_MESSAGE,
    });

    if (!selectedDate) {
      return;
    }

    if (this.selectedWorkspaceInstanceNode?.fields) {
      this.selectedWorkspaceInstanceNode.fields[fieldId] = selectedDate.toISOString();
    }

    this.formChanged = true;
    if (this.myForm && !this.myForm.form.dirty) {
      this.myForm.form.markAsDirty();
    }
    this.saveWork();
  }

  public onClearDate(index: number, fieldId: string): void {
    if (this.formData[fieldId] !== undefined) {
      this.formData[fieldId] = null;
      if (this.selectedWorkspaceInstanceNode?.fields) {
        this.selectedWorkspaceInstanceNode.fields[fieldId] = null;
      }

      if (this.dateCalendarRef) {
        this.dateCalendarRef.overlayVisible = false;
      }

      this.formChanged = true;
      if (this.myForm && !this.myForm.form.dirty) {
        this.myForm.form.markAsDirty();
      }
      this.saveWork();
    }
  }

  public onSetDate(): void {
    if (this.dateCalendarRef) {
      this.dateCalendarRef.overlayVisible = false;
    }
  }

  //todo - use blueprint helper service
  private getFieldIdByName(blueprint: any, fieldName: string): string | undefined {
    if (!blueprint || !Array.isArray(blueprint.fields)) {
      return undefined;
    }

    const field = blueprint.fields.find((f: any) => f.name?.toLowerCase() === fieldName.toLowerCase());

    return field ? String(field.id) : undefined;
  }
}
